var _path, _polygon, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGrowth(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 750 500",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "freepik--clip-path--inject-17"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M205.64,242.33a2.55,2.55,0,1,1-4.38,0h-2.95a2.58,2.58,0,0,1,.36,1.29,2.55,2.55,0,1,1-4.74-1.29h-3a2.48,2.48,0,0,1,.36,1.29,2.55,2.55,0,1,1-4.74-1.29h-2.95a2.48,2.48,0,0,1,.36,1.29,2.55,2.55,0,1,1-5.09,0,2.48,2.48,0,0,1,.36-1.29h-2.95a2.55,2.55,0,1,1-4.74,1.29,2.48,2.48,0,0,1,.36-1.29H169a2.55,2.55,0,1,1-4.38,0h-1.85V295h43.84V242.33Z",
    style: {
      fill: "none"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--background-complete--inject-17"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "330.69 89.74 348.59 146.38 335.63 146.38 329.92 126.85 330.69 89.74",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 99.48,
    y: 146.32,
    width: 267.38,
    height: 15.98,
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 136.74,
    y: 158.81,
    width: 12.94,
    height: 24.53,
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 303.68,
    y: 158.81,
    width: 12.93,
    height: 24.53,
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M108.56,72.24s-12,9.14-.5,21.22a1.06,1.06,0,0,0,.76.32l104.84-.61s9-10,1.52-21.62Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M190.49,81.78c0,.11-13.06.21-29.16.21s-29.16-.1-29.16-.21,13.06-.21,29.16-.21S190.49,81.66,190.49,81.78Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M174.18,85.57c0,.12-6.14.21-13.71.21s-13.71-.09-13.71-.21,6.14-.21,13.71-.21S174.18,85.45,174.18,85.57Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M201.21,92.83c-.07,0,.23-1.2.55-3.15a44.82,44.82,0,0,0,.61-7.64,45.93,45.93,0,0,0-.75-7.64c-.36-1.94-.69-3.12-.62-3.14a3.34,3.34,0,0,1,.31.81c.17.53.38,1.3.6,2.27a37.23,37.23,0,0,1,.15,15.4c-.21,1-.4,1.75-.56,2.28A3.78,3.78,0,0,1,201.21,92.83Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M209,71.42a3.72,3.72,0,0,1,.47.76,10.43,10.43,0,0,1,.46.94c.17.38.37.8.54,1.29a22.93,22.93,0,0,1,1,3.47A26,26,0,0,1,212,82.3a25.25,25.25,0,0,1-.38,4.41,23.86,23.86,0,0,1-.94,3.5c-.16.49-.36.91-.52,1.29a8.65,8.65,0,0,1-.45,1,4.38,4.38,0,0,1-.45.77c-.08,0,.51-1.17,1.13-3.11a24.43,24.43,0,0,0,.84-3.46,28,28,0,0,0,.35-4.35,27.42,27.42,0,0,0-.42-4.34,25.19,25.19,0,0,0-.89-3.45C209.56,72.58,209,71.46,209,71.42Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M125.1,93a3.58,3.58,0,0,1-.49-.7,7.33,7.33,0,0,1-.49-.88c-.17-.35-.38-.74-.56-1.2a18.63,18.63,0,0,1-1-3.31,20.65,20.65,0,0,1-.4-4.22,20.89,20.89,0,0,1,.52-4.21,17.64,17.64,0,0,1,1.11-3.28,11,11,0,0,1,.59-1.19,6.74,6.74,0,0,1,.51-.86c.31-.46.48-.71.51-.69s-.6,1.06-1.34,2.85a20.67,20.67,0,0,0-1,3.25,22,22,0,0,0-.48,4.13,23.33,23.33,0,0,0,.36,4.15,21.46,21.46,0,0,0,.92,3.27C124.53,91.9,125.18,92.93,125.1,93Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M113.78,95.53a5.29,5.29,0,0,1-.54-.8,8.28,8.28,0,0,1-.54-1c-.2-.4-.44-.84-.64-1.35a22.83,22.83,0,0,1-1.2-3.71,26,26,0,0,1-.59-4.73,25.4,25.4,0,0,1,.38-4.75,22.62,22.62,0,0,1,1-3.75,14.48,14.48,0,0,1,.57-1.38,10.58,10.58,0,0,1,.5-1,3.37,3.37,0,0,1,.51-.81c.07,0-.6,1.23-1.3,3.3a24.27,24.27,0,0,0-.93,3.72,24.4,24.4,0,0,0,.2,9.33,24.26,24.26,0,0,0,1.1,3.67C113.13,94.32,113.86,95.48,113.78,95.53Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M209.81,125.09v20.07H171V125.09Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M84.43,135.31l0,.53A11.49,11.49,0,0,0,96,146.61H211.62v-1.45H184.17a10,10,0,0,1-10-10h0a10,10,0,0,1,10-10h27.45V123L96,123.35A11.58,11.58,0,0,0,84.43,135.31Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M209.81,135.39c0,.12-8,.22-17.82.22s-17.83-.1-17.83-.22,8-.21,17.83-.21S209.81,135.28,209.81,135.39Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M209.25,139.91c0,.12-7.55.22-16.87.22s-16.87-.1-16.87-.22,7.55-.21,16.87-.21S209.25,139.8,209.25,139.91Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M209.81,144.05c0,.12-6.79.21-15.16.21s-15.17-.09-15.17-.21,6.79-.21,15.17-.21S209.81,143.93,209.81,144.05Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M209.81,131.33c0,.12-7.82.21-17.46.21s-17.46-.09-17.46-.21,7.81-.21,17.46-.21S209.81,131.22,209.81,131.33Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M209.25,127.27c0,.12-7,.21-15.54.21s-15.55-.09-15.55-.21,7-.21,15.55-.21S209.25,127.15,209.25,127.27Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M98.44,123.69A27.3,27.3,0,0,0,96,126.61a14.87,14.87,0,0,0,.21,17.19,27.72,27.72,0,0,0,2.52,2.87,5.18,5.18,0,0,1-.83-.62A13.55,13.55,0,0,1,96,144a14.61,14.61,0,0,1-.21-17.54,13.36,13.36,0,0,1,1.88-2.11A4,4,0,0,1,98.44,123.69Z",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M94.53,123.26a26.66,26.66,0,0,0-2.45,2.92,14.87,14.87,0,0,0,.2,17.2,28.15,28.15,0,0,0,2.52,2.86,4.48,4.48,0,0,1-.83-.62A13.08,13.08,0,0,1,92,143.55,14.61,14.61,0,0,1,91.83,126a13.36,13.36,0,0,1,1.88-2.11A4,4,0,0,1,94.53,123.26Z",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M173.09,123.69a25.94,25.94,0,0,0-2.46,2.92,14.87,14.87,0,0,0,.21,17.19,26.34,26.34,0,0,0,2.52,2.87,5.18,5.18,0,0,1-.83-.62A13.07,13.07,0,0,1,170.6,144a14.61,14.61,0,0,1-.21-17.54,12.88,12.88,0,0,1,1.88-2.11A4,4,0,0,1,173.09,123.69Z",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M169.18,123.26a27.3,27.3,0,0,0-2.46,2.92,14.89,14.89,0,0,0,.21,17.2,28.15,28.15,0,0,0,2.52,2.86,4.48,4.48,0,0,1-.83-.62,13.08,13.08,0,0,1-1.93-2.07,14.61,14.61,0,0,1-.21-17.54,13.36,13.36,0,0,1,1.88-2.11A4,4,0,0,1,169.18,123.26Z",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M111.6,138.13l-.11-8.16a5.72,5.72,0,0,0-.29-2.1,2,2,0,0,0-1.55-1.3c-1-.46-2.61.4-3.32,1.57a7.69,7.69,0,0,0-.81,4,57.74,57.74,0,0,0,.32,6.44,7.24,7.24,0,0,0,.76,2.95,2.46,2.46,0,0,0,4.66-.39A8.21,8.21,0,0,0,111.6,138.13Z",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M156.5,135.79c0,.11-8.36.21-18.66.21s-18.67-.1-18.67-.21,8.35-.22,18.67-.22S156.5,135.67,156.5,135.79Z",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "103.85 122.89 103.64 103.87 113.99 103.87 114.35 122.89 103.85 122.89",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M113.38,107.25a26.61,26.61,0,0,1-4.81.22,26.61,26.61,0,0,1-4.81-.22,28.42,28.42,0,0,1,4.81-.21A28.42,28.42,0,0,1,113.38,107.25Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M113.38,110.19a27.22,27.22,0,0,1-4.81.21,27.22,27.22,0,0,1-4.81-.21,27.22,27.22,0,0,1,4.81-.21A27.22,27.22,0,0,1,113.38,110.19Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M113.38,113.12a26.61,26.61,0,0,1-4.81.22,26.61,26.61,0,0,1-4.81-.22,28.42,28.42,0,0,1,4.81-.21A28.42,28.42,0,0,1,113.38,113.12Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M113.38,116.06a27.22,27.22,0,0,1-4.81.21,27.22,27.22,0,0,1-4.81-.21,27.22,27.22,0,0,1,4.81-.21A27.22,27.22,0,0,1,113.38,116.06Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M113.38,119a26.61,26.61,0,0,1-4.81.22,26.61,26.61,0,0,1-4.81-.22,28.42,28.42,0,0,1,4.81-.21A28.42,28.42,0,0,1,113.38,119Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M103.09,103.37H217.82c1.42,6.29,1.22,13.22,0,20.55H103.58v-1.4h7a3.29,3.29,0,0,0,3.3-3.29V107.85a3.29,3.29,0,0,0-3.3-3.29h-7.47Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M130.21,113.66h1.92a.35.35,0,0,1,.2,0,.39.39,0,0,1,.21.36.22.22,0,0,1,0,.12c0,.16-.08.33-.12.49a5.49,5.49,0,0,1-1.2,2.17,2.29,2.29,0,0,1-1.64.84h-.23a1.88,1.88,0,0,1-1.3-1,4.29,4.29,0,0,1-.57-2.3,6.24,6.24,0,0,1,.23-1.64,5.55,5.55,0,0,1,1.13-2.22,2.33,2.33,0,0,1,1.73-.92,1.59,1.59,0,0,1,.72.17,2.32,2.32,0,0,1,1.12,1.4.41.41,0,0,1,.05.19.36.36,0,0,1-.06.2.38.38,0,0,1-.35.21l-.13,0a.41.41,0,0,1-.27-.26l0,0a1.9,1.9,0,0,0-.23-.45,1.07,1.07,0,0,0-.91-.55,1.14,1.14,0,0,0-.64.23,3.37,3.37,0,0,0-1,1.51,5.65,5.65,0,0,0-.45,2.16,4,4,0,0,0,.32,1.69,1.12,1.12,0,0,0,1,.75,1.35,1.35,0,0,0,.93-.56,4.92,4.92,0,0,0,1-1.77c-.88,0-1.34,0-1.37,0-.3,0-.45-.2-.46-.46a.57.57,0,0,1,0-.14A.43.43,0,0,1,130.21,113.66Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M136.73,109.92s0,.08.05.14q.12.42,1.35,7.11a.36.36,0,0,1,0,.1.42.42,0,0,1-.06.21.37.37,0,0,1-.34.21h-.07a.37.37,0,0,1-.31-.29l-.46-2.36h-2.36l-1.13,2.37a.2.2,0,0,1,0,.08.42.42,0,0,1-.35.2.4.4,0,0,1-.22-.06.41.41,0,0,1-.19-.35.5.5,0,0,1,0-.12c.07-.17.19-.43.35-.78q2.47-5.4,3-6.38a.46.46,0,0,1,.4-.28A.43.43,0,0,1,136.73,109.92Zm-.52,1.59-1.27,2.68h1.8Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M143.13,117.69h-3.46a.43.43,0,0,1-.22-.06.65.65,0,0,1-.2-.44h0q0-.21,1-7.08a.77.77,0,0,1,0-.15.37.37,0,0,1,.37-.26.41.41,0,0,1,.19,0,.4.4,0,0,1,.22.37c0,.31-.11,1-.24,1.94-.39,3-.6,4.62-.62,4.78h2.94a.78.78,0,0,1,.22,0,.39.39,0,0,1,.26.39.27.27,0,0,1,0,.13A.47.47,0,0,1,143.13,117.69Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M147.85,109.92a1,1,0,0,1,.06.14q.12.42,1.35,7.11a.36.36,0,0,1,0,.1.42.42,0,0,1-.06.21.38.38,0,0,1-.34.21h-.07a.38.38,0,0,1-.32-.29L148,115h-2.36l-1.13,2.37a.2.2,0,0,1,0,.08.45.45,0,0,1-.35.2.46.46,0,0,1-.23-.06.43.43,0,0,1-.19-.35.27.27,0,0,1,0-.12c.07-.17.19-.43.35-.78q2.48-5.4,3-6.38a.45.45,0,0,1,.4-.28A.42.42,0,0,1,147.85,109.92Zm-.51,1.59-1.27,2.68h1.8Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M153.36,114c.27.75.48,1.33.63,1.73.36,1,.53,1.51.53,1.56a.37.37,0,0,1-.06.21.4.4,0,0,1-.35.19.36.36,0,0,1-.34-.28l-.07-.17c-.18-.43-.49-1.24-.92-2.44l-2,2.68a.46.46,0,0,1-.36.21.54.54,0,0,1-.22,0,.39.39,0,0,1-.19-.35v-.09a1,1,0,0,1,.21-.33c.66-.85,1.38-1.86,2.17-3-.08-.23-.16-.45-.24-.65-.73-2-1.1-3-1.1-3.06a.54.54,0,0,1,0-.21.36.36,0,0,1,.34-.2.41.41,0,0,1,.38.22l1.16,3.12,2.3-3.14a.47.47,0,0,1,.37-.2.41.41,0,0,1,.19,0,.38.38,0,0,1,.2.36.43.43,0,0,1,0,.19Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M161.92,109.74a.41.41,0,0,1,.19.05.39.39,0,0,1,.22.35c-.56,4.47-.88,6.89-.93,7.25a4.49,4.49,0,0,1-.74,1.89,2.7,2.7,0,0,1-2.3,1.12,2.65,2.65,0,0,1-1.11-.29A2.46,2.46,0,0,1,156,119a.45.45,0,0,1,0-.2.54.54,0,0,1,0-.21.41.41,0,0,1,.36-.2.38.38,0,0,1,.31.17,2.23,2.23,0,0,0,1.77,1,1.79,1.79,0,0,0,1.38-.7,3.82,3.82,0,0,0,.76-2.17,2.16,2.16,0,0,1-.51.54,2.06,2.06,0,0,1-1.24.4h-.23a1.83,1.83,0,0,1-1.31-1,4.2,4.2,0,0,1-.58-2.3c0-.42,0-.85.06-1.3.06-.7.22-1.69.46-3a.56.56,0,0,1,0-.12.39.39,0,0,1,.37-.28.36.36,0,0,1,.2.06.37.37,0,0,1,.21.33c0,.21-.07.73-.19,1.57a23.17,23.17,0,0,0-.28,2.41,5,5,0,0,0,.31,1.88c.24.56.58.84,1,.84h.14a1.92,1.92,0,0,0,1-.83,5,5,0,0,0,.85-1.91l.53-3.94a.48.48,0,0,1,.05-.17A.39.39,0,0,1,161.92,109.74Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M213.51,124.19c-.12,0-.21-4.72-.21-10.54s.09-10.55.21-10.55.21,4.72.21,10.55S213.63,124.19,213.51,124.19Z",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M119.63,124.19c-.12,0-.21-4.72-.21-10.54s.09-10.55.21-10.55.21,4.72.21,10.55S119.74,124.19,119.63,124.19Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M215.52,124.19c-.11,0-.21-4.72-.21-10.54s.1-10.55.21-10.55.22,4.72.22,10.55S215.64,124.19,215.52,124.19Z",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M117.75,124.19c-.12,0-.22-4.72-.22-10.54s.1-10.55.22-10.55.21,4.72.21,10.55S117.86,124.19,117.75,124.19Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M185.69,106.57l0,0,12.13,9.78.11.09-.14,0-1.61.43-10.24,2.68h0l-9.28-3.93L174,114.49l-.7-.3-.17-.08-.06,0,.06,0,.18.07.7.28,2.64,1.1,9.3,3.88h0l10.24-2.7,1.61-.42,0,.12-12.1-9.82h0v0",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "196.7 114.8 197.37 115.42 198.25 115.23 197.86 116.05 198.32 116.83 197.42 116.72 196.82 117.4 196.65 116.5 195.82 116.14 196.61 115.7 196.7 114.8",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "185.07 118.65 185.52 119.03 186.09 118.87 185.87 119.42 186.2 119.91 185.61 119.87 185.25 120.33 185.1 119.76 184.55 119.55 185.05 119.24 185.07 118.65",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "172.22 113.38 172.94 113.43 173.39 112.86 173.57 113.56 174.25 113.81 173.64 114.19 173.61 114.91 173.06 114.45 172.36 114.65 172.63 113.98 172.22 113.38",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "202.14 106.73 202.86 106.77 203.31 106.21 203.49 106.91 204.16 107.15 203.55 107.54 203.53 108.26 202.97 107.8 202.28 108 202.54 107.33 202.14 106.73",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "185.1 106.26 185.56 106.28 185.85 105.92 185.96 106.37 186.4 106.53 186.01 106.77 185.99 107.23 185.63 106.94 185.19 107.07 185.36 106.64 185.1 106.26",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M203.15,107.23s-3.92-.08-8.76-.29-8.76-.41-8.75-.46,3.92.09,8.76.29S203.15,107.19,203.15,107.23Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M207.56,103.19H91.2c-1.53-3.46-1.9-6.74,0-9.69H207.56A11.28,11.28,0,0,1,207.56,103.19Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 115.29,
    y: 96.27,
    width: 63.04,
    height: 3.52,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M95.66,103.24a3.51,3.51,0,0,1-.92-1.17,8.68,8.68,0,0,1-1.06-3.44,8.55,8.55,0,0,1,.45-3.57,3.4,3.4,0,0,1,.7-1.31,11.61,11.61,0,0,1-.42,1.4,10.4,10.4,0,0,0-.31,3.45,10.26,10.26,0,0,0,.91,3.33A10.92,10.92,0,0,1,95.66,103.24Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M98.18,103.24a3.51,3.51,0,0,1-.92-1.17,8.52,8.52,0,0,1-1.06-3.44,8.39,8.39,0,0,1,.45-3.57,3.4,3.4,0,0,1,.7-1.31,11.61,11.61,0,0,1-.42,1.4,10.14,10.14,0,0,0-.31,3.45,9.78,9.78,0,0,0,.91,3.33A10.92,10.92,0,0,1,98.18,103.24Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M202.85,103a20.31,20.31,0,0,0,.82-4.74,20.2,20.2,0,0,0-.77-4.75,9.87,9.87,0,0,1-.05,9.49Z",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M200.68,103c-.12,0,.37-2.07.35-4.64s-.49-4.6-.36-4.63a14.08,14.08,0,0,1,0,9.27Z",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "250.84 43.18 330.69 43.18 330.69 147.38 251.38 147.38 250.84 43.18",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 245.04,
    y: 43.69,
    width: 79.39,
    height: 103.14,
    transform: "translate(569.46 190.52) rotate(180)",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M324.82,43.3V147.22H244.64V43.3ZM324,146.44V44.08h-78.6V146.44Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 253.32,
    y: 54.88,
    width: 60.78,
    height: 80.8,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M253.2,54.86s0,.14,0,.39,0,.65,0,1.14c0,1,0,2.48,0,4.4,0,3.85,0,9.46,0,16.57,0,14.21.05,34.38.09,58.3l-.18-.19,60.77,0h0l-.21.21c0-30.09,0-58,0-80.8L314,55l-44.14-.09-12.29,0-3.23,0-1.12,0,1.08,0,3.21,0,12.25,0L314,54.69h.16v.17c0,22.82,0,50.71,0,80.8v.2H314l-60.77,0H253v-.18c0-24,.07-44.18.09-58.42,0-7.09,0-12.69.05-16.53,0-1.9,0-3.36,0-4.36,0-.49,0-.86,0-1.12S253.2,54.86,253.2,54.86Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M244.85,146.83a11.18,11.18,0,0,1,1.07-1.75c.71-1,1.71-2.47,2.85-4s2.23-2.92,3-3.89a8.9,8.9,0,0,1,1.39-1.51,12.12,12.12,0,0,1-1.16,1.69l-2.94,4-2.94,3.95A10.13,10.13,0,0,1,244.85,146.83Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M245,43.69a58.48,58.48,0,0,1,4.24,5.46,58.16,58.16,0,0,1,3.92,5.71A55.64,55.64,0,0,1,249,49.4,59,59,0,0,1,245,43.69Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 324.43,
    y1: 43.69,
    x2: 313.98,
    y2: 55.27,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M314,55.27a72.78,72.78,0,0,1,5.07-5.93,71.87,71.87,0,0,1,5.38-5.65,74.73,74.73,0,0,1-5.08,5.93A73,73,0,0,1,314,55.27Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M324.43,146.83a68.41,68.41,0,0,1-5.15-5.39,66.84,66.84,0,0,1-4.83-5.67,71.78,71.78,0,0,1,5.14,5.39A70.65,70.65,0,0,1,324.43,146.83Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M256.1,135.66s6.54-20.26,10.43-22.42a37.36,37.36,0,0,1,17.07-4.62c9-.08,13.28.59,18.56,4.22,6.09,4.19,10.22,22.61,10.22,22.61",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M274.24,75.32c-5.59.25-7,7.76-6.58,12,.18,2,.8,4.24-.22,6-.73,1.25-2.16,2-2.76,3.31-.74,1.59,0,3.43.5,5.1s.76,3.79-.58,4.93a48.42,48.42,0,0,0,9.65,1.81,16.33,16.33,0,0,0,9.46-2.1",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M270.25,90.31c-3.69-8.45,1.31-13.62,4.58-15.48a13.79,13.79,0,0,1,6.48-1.4,23.71,23.71,0,0,1,6.57.58,11.85,11.85,0,0,1,5.7,3.19c2.69,2.86,3.31,7.1,3.07,11a30.68,30.68,0,0,1-3.86,13.17,3.15,3.15,0,0,1-1.14,1.33,1.19,1.19,0,0,1-1.58-.28",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M282.7,119.3c3.79.26,7.11-3,7.5-8.85l2-29.72-.14,2.06a2.4,2.4,0,0,0-2.15-2.42l-11.77-1.21a7.16,7.16,0,0,0-7.89,6.71c-.27,4.52-.43,10.06.12,13.43,1.1,6.78,6.3,7.63,6.3,7.63l-.4,4.93a6.88,6.88,0,0,0,6.4,7.44Z",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M272.54,89.7a.86.86,0,0,0,.84.87.84.84,0,0,0,.9-.79.87.87,0,0,0-.85-.87A.83.83,0,0,0,272.54,89.7Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M271.49,88.74c.11.11.76-.38,1.7-.38s1.63.47,1.73.36-.06-.26-.36-.48a2.49,2.49,0,0,0-1.39-.42,2.32,2.32,0,0,0-1.35.44C271.53,88.49,271.44,88.69,271.49,88.74Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M281.54,89.7a.86.86,0,0,0,.84.87.82.82,0,0,0,.89-.79.86.86,0,0,0-.84-.87A.82.82,0,0,0,281.54,89.7Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M280.7,88.89c.1.11.76-.38,1.7-.38s1.62.47,1.73.35-.06-.25-.37-.47a2.43,2.43,0,0,0-1.38-.42,2.25,2.25,0,0,0-1.35.44C280.74,88.63,280.64,88.84,280.7,88.89Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M277.32,95.85a5.53,5.53,0,0,0-1.53-.27c-.23,0-.46-.08-.5-.24a1.17,1.17,0,0,1,.16-.71c.22-.58.45-1.18.7-1.82A31,31,0,0,0,277.72,88a31.94,31.94,0,0,0-2,4.63c-.24.64-.46,1.25-.67,1.84a1.38,1.38,0,0,0-.13.93.62.62,0,0,0,.4.35,1.62,1.62,0,0,0,.4.06A6.38,6.38,0,0,0,277.32,95.85Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M276.7,106.93a17.31,17.31,0,0,0,9.09-2.45s-2.43,4.7-9.22,4.09Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M277.72,98.1a1.7,1.7,0,0,1,1.51-.63,1.54,1.54,0,0,1,1.07.57,1,1,0,0,1,.07,1.11,1.13,1.13,0,0,1-1.22.32,3.57,3.57,0,0,1-1.2-.71,1,1,0,0,1-.27-.28.32.32,0,0,1,0-.35",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M280.08,96.49c-.16,0-.16,1-1,1.73s-1.95.61-2,.76.24.19.7.2a2.49,2.49,0,0,0,1.63-.57,2.21,2.21,0,0,0,.79-1.45C280.26,96.73,280.15,96.48,280.08,96.49Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M280.27,87.25c.09.26,1,.13,2.13.26s2,.43,2.13.2-.09-.35-.45-.6a3.57,3.57,0,0,0-1.58-.54,3.35,3.35,0,0,0-1.66.2C280.43,86.93,280.23,87.13,280.27,87.25Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M271.82,86c.17.21.81,0,1.59,0s1.43.14,1.59-.09,0-.32-.33-.52a2.18,2.18,0,0,0-1.29-.34,2.1,2.1,0,0,0-1.26.43C271.84,85.71,271.75,85.93,271.82,86Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M275.58,74.43c6.57-3.7,13.63-1.11,18.95,4.23,1.18,1.18,2.23,2.57,3.76,3.22s3.85.6,4.84,2.1c1.14,1.76-.4,4.24.43,6.17.78,1.77,3.21,2.28,4.11,4,.71,1.34.27,3-.07,4.45s-.46,3.26.65,4.29l-14.14,5.37a3.68,3.68,0,0,1-2,.22c-2-.4-2.16-2.26-2-3.8a6.38,6.38,0,0,0-.09-3.42c-.58-1.25-2-1.91-2.55-3.18-.92-2.24,1.62-4.57,1.31-7a4.51,4.51,0,0,0-2.88-3.27c-1.39-.6-2.93-.8-4.37-1.27-3.34-1.06-6.09-4.12-7.51-7.52a3.66,3.66,0,0,1,1.52-4.61Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 559.7,
    y: 79.16,
    width: 127.29,
    height: 132.69,
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 551.08,
    y: 79.16,
    width: 127.29,
    height: 132.69,
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M678.41,211.89H551V79.12H678.41Zm-127.29-.08H678.33V79.2H551.12Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 568.19,
    y: 97,
    width: 93.07,
    height: 97.02,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M568.19,194.66a15.25,15.25,0,0,1-2.3,2.67c-1.49,1.57-3.57,3.69-5.91,6s-4.5,4.36-6.09,5.82a14.13,14.13,0,0,1-2.69,2.24,14.93,14.93,0,0,1,2.29-2.66c1.49-1.57,3.58-3.7,5.93-6s4.5-4.37,6.09-5.83A14.17,14.17,0,0,1,568.19,194.66Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M661.26,194.42a15.7,15.7,0,0,1,2.67,2.3c1.57,1.49,3.69,3.58,6,5.92s4.36,4.49,5.81,6.08a14.87,14.87,0,0,1,2.25,2.69,14.15,14.15,0,0,1-2.66-2.29c-1.57-1.48-3.7-3.58-6-5.93s-4.38-4.5-5.83-6.09A14.17,14.17,0,0,1,661.26,194.42Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M661,97.26a15.25,15.25,0,0,1,2.3-2.67c1.49-1.57,3.57-3.69,5.92-6s4.49-4.36,6.08-5.82A14.13,14.13,0,0,1,678,80.53a14.93,14.93,0,0,1-2.29,2.66c-1.49,1.57-3.58,3.7-5.93,6s-4.5,4.37-6.09,5.83A14.17,14.17,0,0,1,661,97.26Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M567.93,97.5a15.7,15.7,0,0,1-2.67-2.3c-1.57-1.49-3.69-3.57-6-5.92s-4.37-4.49-5.82-6.08a14,14,0,0,1-2.24-2.69,14.71,14.71,0,0,1,2.65,2.29c1.57,1.48,3.7,3.58,6,5.93s4.38,4.5,5.83,6.09A14.17,14.17,0,0,1,567.93,97.5Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M661,194s0-.17,0-.47,0-.78,0-1.36c0-1.22,0-3,0-5.24,0-4.59,0-11.28-.09-19.77-.05-17-.11-41.2-.19-70.18l.36.36-92.8,0h0l.41-.41c0,35.61,0,68.92-.06,97l-.35-.36,67.2.18,18.88.1,5,0,1.29,0a2.28,2.28,0,0,1,.45,0l-.41,0-1.25,0-4.93,0-18.79.09-67.43.18h-.36V194c0-28.1,0-61.41-.05-97v-.41h.42l92.8,0h.36V97c-.07,29.08-.14,53.36-.18,70.41,0,8.46-.07,15.12-.09,19.69,0,2.24,0,4-.05,5.17,0,.56,0,1,0,1.32A2,2,0,0,1,661,194Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M634,126.6a34.89,34.89,0,0,0-35.06-4.4s-1.74,23-1.61,33.08,10.16,11.6,10.16,11.6l0,10.87,24.4.92,3.64-50.92Z",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M607.46,166.74A23.4,23.4,0,0,0,620.55,163s-3.09,7.22-13.11,6.32Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M634.24,138.14c.17-.07,6.9-2,6.68,4.83s-7.07,5.22-7.07,5S634.24,138.14,634.24,138.14Z",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M636,145.46s.11.09.31.19a1.21,1.21,0,0,0,.9,0,3,3,0,0,0,1.45-2.61,3.94,3.94,0,0,0-.28-1.72,1.39,1.39,0,0,0-.87-1,.61.61,0,0,0-.72.3c-.1.19-.06.33-.09.34s-.15-.12-.08-.4a.8.8,0,0,1,.28-.42.88.88,0,0,1,.67-.15,1.65,1.65,0,0,1,1.21,1.1,4,4,0,0,1,.36,1.93c-.09,1.38-.84,2.65-1.84,2.9a1.28,1.28,0,0,1-1.09-.21C636,145.63,636,145.48,636,145.46Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M602.22,137.64a1.45,1.45,0,0,0,1.39,1.45,1.37,1.37,0,0,0,1.47-1.3,1.43,1.43,0,0,0-1.38-1.44A1.37,1.37,0,0,0,602.22,137.64Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M600.83,136.32c.18.18,1.27-.62,2.81-.62s2.67.78,2.84.59-.1-.42-.59-.78a4,4,0,0,0-2.28-.7,3.8,3.8,0,0,0-2.23.72C600.91,135.89,600.74,136.23,600.83,136.32Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M617.39,138.29a1.44,1.44,0,0,0,1.38,1.45,1.38,1.38,0,0,0,1.48-1.3,1.44,1.44,0,0,0-1.38-1.44A1.36,1.36,0,0,0,617.39,138.29Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M616,136.6c.18.19,1.27-.61,2.81-.61s2.68.78,2.84.59-.09-.42-.59-.78a3.85,3.85,0,0,0-2.27-.7,3.79,3.79,0,0,0-2.24.72C616.07,136.18,615.91,136.52,616,136.6Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M610.4,148a10.94,10.94,0,0,0-2.51-.45c-.39,0-.77-.12-.83-.39a2,2,0,0,1,.26-1.16q.55-1.44,1.17-3c1.61-4.27,2.78-7.78,2.61-7.85s-1.62,3.35-3.24,7.62c-.39,1.05-.76,2.06-1.12,3a2.32,2.32,0,0,0-.2,1.54,1,1,0,0,0,.65.58,2.43,2.43,0,0,0,.67.09A9.5,9.5,0,0,0,610.4,148Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M615.6,130.56c.15.42,1.69.22,3.5.44s3.27.71,3.51.33c.11-.18-.14-.57-.73-1a6,6,0,0,0-2.61-.91,5.82,5.82,0,0,0-2.74.32C615.87,130,615.53,130.36,615.6,130.56Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M601.4,131.85c.27.35,1.33,0,2.61,0s2.36.24,2.61-.13c.11-.18-.06-.53-.53-.86a3.62,3.62,0,0,0-2.13-.57,3.52,3.52,0,0,0-2.08.7C601.43,131.32,601.28,131.68,601.4,131.85Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M594,115.86a3.7,3.7,0,0,1,1.37-3.31,2.64,2.64,0,0,1,3.41.25,3.06,3.06,0,0,1,2.63-3.72c1.64-.1,3,1.14,4.62,1.57a7.44,7.44,0,0,0,4.68-.54c1.49-.6,2.88-1.43,4.38-2a12.84,12.84,0,0,1,16.42,7.53,5.7,5.7,0,0,1,6,2.29,9.37,9.37,0,0,1,1.44,6.59,21.4,21.4,0,0,1-1.15,4.5c0,.13,0,.26,0,.39-.11,5.52-.73,12-3.08,12-4.11.07-3.13-7.67-3.13-7.67-5-1.94-3.16-9.49-4.42-10.63s-3.9-3.81-14.44,1.58c-4.1,2.09-9.54,2-12.51,1.35l-.27,0H600l-.08,0a9.35,9.35,0,0,1-2.71-1.14,5.46,5.46,0,0,1-2.23-2.48,2.93,2.93,0,0,1,.58-3.14A6.48,6.48,0,0,1,594,115.86Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M610.41,155.51a4.59,4.59,0,0,0,1.77-.21,2.55,2.55,0,0,0,1.33-1.22,2.62,2.62,0,0,0,0-2.16,2.69,2.69,0,0,0-.28-.5c-.14-.14-.11-.13-.25-.11s-.36.14-.53.21l-.55.22c-.71.29-1.35.54-1.89.74a5.6,5.6,0,0,1-1.8.54,5.9,5.9,0,0,1,1.64-.92c.52-.26,1.14-.55,1.84-.86l.53-.24a5.43,5.43,0,0,1,.61-.25.7.7,0,0,1,.49,0,1,1,0,0,1,.36.28,3,3,0,0,1,.28,3.28,2.84,2.84,0,0,1-1.68,1.36,2.78,2.78,0,0,1-1.44.06C610.55,155.66,610.4,155.55,610.41,155.51Z",
    style: {
      fill: "#e0e0e0"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Chair--inject-17"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M459.13,329.84a16.4,16.4,0,0,1,16-13.77c34.54-.46,122.48-1.25,127.2,2.49,5.88,4.67,9,7.06,8.49,14.47-.43,6.8-7.84,124.29-7.84,124.29H438.37Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M584.2,457.38a2.49,2.49,0,0,1-.05-.35c0-.25,0-.59-.08-1-.07-.92-.17-2.24-.29-3.91s-.26-3.79-.34-6.21-.24-5.18-.24-8.23c0-1.53,0-3.13-.05-4.79s0-3.4.06-5.19c0-3.59.21-7.42.38-11.45.46-8.06,1.22-16.9,2.45-26.13s2.91-18,4.62-25.85c.91-3.93,1.75-7.67,2.69-11.14.46-1.73.87-3.41,1.33-5s.91-3.13,1.33-4.6c.82-2.94,1.71-5.55,2.43-7.87s1.41-4.28,2-5.89,1-2.82,1.32-3.7l.36-1c.08-.21.13-.32.13-.32a1.58,1.58,0,0,1-.08.34l-.31,1c-.29.89-.7,2.14-1.23,3.74s-1.21,3.59-1.9,5.91-1.56,4.94-2.35,7.88c-.42,1.47-.85,3-1.3,4.61s-.85,3.29-1.3,5c-.92,3.46-1.74,7.21-2.64,11.13-1.69,7.88-3.29,16.6-4.57,25.82s-2,18-2.49,26.08c-.18,4-.4,7.85-.43,11.44,0,1.79-.09,3.52-.09,5.18s0,3.26,0,4.78c0,3.05.11,5.81.17,8.23s.15,4.5.24,6.2.15,3,.19,3.93c0,.42,0,.76,0,1A1.88,1.88,0,0,1,584.2,457.38Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M491.65,375.21s.08,0,.25-.1a2.42,2.42,0,0,1,.76,0,3.43,3.43,0,0,1,2.41,1.42,3.93,3.93,0,0,1,.24,4.1,5.25,5.25,0,0,1-1.6,1.93,5,5,0,0,1-2.55.89,4.14,4.14,0,0,1-2.63-.69,3.28,3.28,0,0,1-1.36-2.14,4.47,4.47,0,0,1,1.26-3.94c1.85-1.58,3.48-1.63,3.45-1.48s-.09,0-.25,0a4.16,4.16,0,0,0-.7.24,7.23,7.23,0,0,0-2.24,1.45,4.16,4.16,0,0,0-1.05,3.59,2.79,2.79,0,0,0,1.18,1.81,3.62,3.62,0,0,0,2.3.59,4.49,4.49,0,0,0,2.29-.79,4.55,4.55,0,0,0,1.47-1.72,3.58,3.58,0,0,0-.11-3.68,3.41,3.41,0,0,0-2.13-1.43A8,8,0,0,0,491.65,375.21Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M517.46,360.28c0,.11-1.7-.2-4.42.05A20.26,20.26,0,0,0,496.44,372c-1.17,2.47-1.45,4.16-1.56,4.14a4.72,4.72,0,0,1,.19-1.19,17,17,0,0,1,1-3.1A19.7,19.7,0,0,1,513,360a17.75,17.75,0,0,1,3.27.09A4.59,4.59,0,0,1,517.46,360.28Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M469.72,390.85a3.46,3.46,0,0,1,.39-.85,12.77,12.77,0,0,1,1.45-2.08,15.43,15.43,0,0,1,15.18-5.18,13.65,13.65,0,0,1,2.42.77,3.62,3.62,0,0,1,.83.43c0,.1-1.24-.47-3.32-.84a16.08,16.08,0,0,0-14.84,5.06C470.42,389.72,469.81,390.9,469.72,390.85Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M501.57,394.94a6.38,6.38,0,0,1-1.69-1.22,18.87,18.87,0,0,1-3.27-3.85,18.44,18.44,0,0,1-2.13-4.57,6,6,0,0,1-.41-2.05,36.91,36.91,0,0,0,3,6.34A38.71,38.71,0,0,0,501.57,394.94Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M547.23,376.6s.08-.05.25-.1a2.42,2.42,0,0,1,.76,0,3.47,3.47,0,0,1,2.41,1.42,4,4,0,0,1,.25,4.1,5.28,5.28,0,0,1-1.61,1.93,5,5,0,0,1-2.55.89,4.14,4.14,0,0,1-2.63-.69,3.32,3.32,0,0,1-1.36-2.14A4.47,4.47,0,0,1,544,378c1.85-1.57,3.48-1.63,3.45-1.48s-.09,0-.25.05a4.16,4.16,0,0,0-.7.24,7.23,7.23,0,0,0-2.24,1.45,4.16,4.16,0,0,0-1,3.59,2.83,2.83,0,0,0,1.18,1.81,3.62,3.62,0,0,0,2.3.59,4.49,4.49,0,0,0,2.29-.79,4.55,4.55,0,0,0,1.47-1.72,3.58,3.58,0,0,0-.11-3.68,3.41,3.41,0,0,0-2.13-1.43A8,8,0,0,0,547.23,376.6Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M573,361.67c0,.11-1.7-.2-4.42.05A20.26,20.26,0,0,0,552,373.35c-1.17,2.47-1.45,4.16-1.56,4.14a4.72,4.72,0,0,1,.19-1.19,17,17,0,0,1,1-3.1,19.7,19.7,0,0,1,16.91-11.85,17.75,17.75,0,0,1,3.27.09A4.59,4.59,0,0,1,573,361.67Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M525.3,392.24a3.46,3.46,0,0,1,.39-.85,13.45,13.45,0,0,1,1.45-2.08,15.48,15.48,0,0,1,15.18-5.18,14.09,14.09,0,0,1,2.43.77,3,3,0,0,1,.82.44c0,.09-1.24-.48-3.32-.85a16.06,16.06,0,0,0-14.83,5.06C526,391.11,525.39,392.29,525.3,392.24Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M557.15,396.33a6.38,6.38,0,0,1-1.69-1.22,19.19,19.19,0,0,1-3.27-3.85,18.44,18.44,0,0,1-2.13-4.57,6,6,0,0,1-.41-2,37,37,0,0,0,3,6.33A38.71,38.71,0,0,0,557.15,396.33Z",
    style: {
      fill: "#263238"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Cushion--inject-17"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M616.61,293.43c-44.3-43.77-99.46-54.22-99.46-54.22-32.8,19.56-54.93,52.39-71.78,91.79,28.26,26.15,64.6,51.22,95.7,53.52C590.25,372.09,616.61,293.43,616.61,293.43Z",
    style: {
      fill: "#E59124"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.4
    }
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M616.61,293.43c-44.3-43.77-99.46-54.22-99.46-54.22-32.8,19.56-54.93,52.39-71.78,91.79,28.26,26.15,64.6,51.22,95.7,53.52C590.25,372.09,616.61,293.43,616.61,293.43Z"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M600.82,328.18a1.58,1.58,0,0,1-.11-.3l-.28-.9c-.25-.82-.6-2-1.06-3.52l-3.89-13.23.19.11-21.73,7,.14-.13a.64.64,0,0,1-.06.11c-.06.08-.21.12-.26.08a.28.28,0,0,1-.14-.14.9.9,0,0,1,0-.16l0-.24,0-.44,0-.89v-1.78c0-1.2,0-2.41,0-3.65,0-2.47,0-5,0-7.62s-.11-5.28-.26-8a71.72,71.72,0,0,0-.86-8.29l.31.2L552.94,291l-12,2.79-.26.06,0-.26c-1.78-9.34-3.48-18.21-5-26.39l.3.19a178.15,178.15,0,0,1-31.56,5.51l-.16,0,0-.16c-.83-6.8-1.49-12.2-1.94-15.93-.22-1.83-.38-3.26-.5-4.24-.05-.47-.08-.83-.11-1.1a3.52,3.52,0,0,1,0-.37,1.31,1.31,0,0,1,.07.36c0,.27.1.63.17,1.09.13,1,.33,2.41.58,4.24.49,3.72,1.2,9.12,2.09,15.91l-.18-.15A181.32,181.32,0,0,0,535.72,267l.25-.07,0,.25c1.57,8.18,3.28,17.05,5.07,26.38l-.31-.2,12-2.8,19.76-4.58.26-.06,0,.26a69.3,69.3,0,0,1,.85,8.35c.15,2.73.21,5.41.25,8s0,5.16,0,7.63c0,1.24,0,2.46,0,3.65,0,.6,0,1.19,0,1.78v.88l0,.42,0,.2v.05s.05,0,0,0-.1,0-.13.05,0,0,0,0l-.13-.08-.11-.05.25-.08L595.58,310l.15-.05,0,.16,3.75,13.27,1,3.54.24.91A1.12,1.12,0,0,1,600.82,328.18Z",
    style: {
      fill: "#E59124"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M592.35,342.11a1.17,1.17,0,0,1-.1-.23c-.07-.18-.16-.41-.27-.71l-1-2.76c-.86-2.44-2.1-6-3.68-10.51l.17.09-25.9,6.92-.24.06,0-.24c-.62-4.77-1.31-9.88-2.07-15.27s-1.57-11.07-2.61-16.9l.31.2-19,4.41-12.84,3-.26.06,0-.27c-1.78-9.33-3.47-18.2-5-26.38l.3.18a178.28,178.28,0,0,1-31.56,5.52h-.16l0-.15c-.83-6.8-1.49-12.21-1.94-15.93-.21-1.84-.38-3.26-.49-4.25-.05-.46-.09-.83-.12-1.09a2.16,2.16,0,0,1,0-.38,2.41,2.41,0,0,1,.07.37c0,.27.09.63.16,1.09.13,1,.33,2.4.58,4.23.49,3.73,1.2,9.12,2.09,15.91l-.18-.14A181.32,181.32,0,0,0,520,283.29l.25-.07,0,.25c1.57,8.18,3.28,17,5.08,26.38l-.31-.21,12.83-3,19-4.39.26-.06,0,.26c1,5.85,1.83,11.53,2.59,16.92s1.42,10.51,2,15.28l-.27-.18,25.94-6.77.12,0,.05.12c1.52,4.53,2.72,8.1,3.55,10.55.39,1.21.7,2.14.92,2.79.09.3.17.53.22.71Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M575,363.67s0-.29,0-.83.11-1.37.2-2.41c.19-2.14.46-5.25.81-9.23l.17.14-26.86,8.92-.23.08,0-.24c-2.12-11-4.62-24-7.34-38.09l.31.2L525.63,326l-15.37,3.56-.26.06-.05-.26c-1.78-9.34-3.47-18.21-5-26.38l.29.18a178.59,178.59,0,0,1-31.56,5.52h-.16l0-.16c-.83-6.8-1.49-12.21-1.94-15.93-.21-1.84-.38-3.26-.49-4.24-.05-.47-.09-.83-.12-1.09a2.17,2.17,0,0,1,0-.38s0,.13.07.37.09.62.16,1.09c.13,1,.33,2.4.58,4.23.49,3.72,1.19,9.11,2.09,15.91l-.18-.14a181.49,181.49,0,0,0,31.46-5.64l.25-.07.05.25c1.57,8.17,3.28,17,5.08,26.37l-.31-.2,15.37-3.57L542,321.71l.26-.06,0,.27c2.68,14.09,5.16,27.1,7.25,38.1l-.27-.16,26.91-8.77.18-.06,0,.2c-.4,4-.71,7.07-.93,9.21-.11,1-.2,1.84-.26,2.41S575,363.67,575,363.67Z",
    style: {
      fill: "#E59124"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M539.25,384.36l-.06-.19-.16-.57c-.13-.53-.32-1.27-.57-2.21-.48-2-1.18-4.82-2.07-8.42s-1.91-8-3.1-13-2.48-10.69-3.68-16.91l.28.19-31.79,7.4-.27.07-.05-.27c-.16-.87-.34-1.81-.52-2.75-1.58-8.25-3.1-16.2-4.52-23.63l.31.19a177.22,177.22,0,0,1-31.56,5.52l-.18,0,0-.18c-.81-6.69-1.47-12.1-1.92-15.85-.22-1.85-.38-3.29-.5-4.29-.05-.47-.09-.84-.11-1.12a1.81,1.81,0,0,1,0-.38,1.74,1.74,0,0,1,.08.38l.16,1.1c.14,1,.34,2.44.59,4.28.5,3.75,1.21,9.15,2.09,15.84l-.19-.16a181.19,181.19,0,0,0,31.46-5.64l.25-.07.06.26c1.42,7.44,2.95,15.38,4.54,23.63.18.94.36,1.88.52,2.75l-.31-.2,31.81-7.36.23-.05.05.24c1.17,6.2,2.48,11.86,3.6,16.9s2.15,9.43,3,13.07,1.49,6.46,1.94,8.44c.22,1,.38,1.7.5,2.24l.12.57C539.25,384.29,539.26,384.36,539.25,384.36Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M522.36,380.78a8.43,8.43,0,0,1-.37-1.38l-.86-3.86c-.7-3.27-1.66-7.85-2.71-13l.31.2-3,.7c-5.85,1.36-11.16,2.56-15,3.4l-4.56,1a11.55,11.55,0,0,1-1.69.29,9.87,9.87,0,0,1,1.64-.49l4.53-1.13c3.82-.94,9.12-2.2,15-3.56l3-.69.26-.06,0,.26c1,5.19,1.92,9.78,2.54,13.07.28,1.59.52,2.89.7,3.89A9.09,9.09,0,0,1,522.36,380.78Z",
    style: {
      fill: "#E59124"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M485.48,362.56a8.75,8.75,0,0,1-.37-1.41c-.22-1-.5-2.32-.83-3.89-.68-3.28-1.58-7.83-2.55-12.86-.05-.31-.11-.61-.17-.9l.33.2c-4.76,1.29-9.08,2.21-12.21,2.77-1.56.29-2.83.49-3.71.61a6.9,6.9,0,0,1-1.37.14,7.86,7.86,0,0,1,1.34-.33l3.67-.77c3.11-.66,7.4-1.63,12.14-2.92l.27-.07.05.27.18.9c1,5,1.8,9.59,2.39,12.89.27,1.58.49,2.9.67,3.92A7.73,7.73,0,0,1,485.48,362.56Z",
    style: {
      fill: "#E59124"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M448.37,333.75a19.64,19.64,0,0,1-.8-6.34,10.08,10.08,0,0,1,.66,3.14A9.77,9.77,0,0,1,448.37,333.75Z",
    style: {
      fill: "#E59124"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M608.29,313.57a.83.83,0,0,1-.06-.25c0-.18-.09-.42-.15-.73-.12-.67-.29-1.62-.52-2.85-.45-2.52-1.09-6.18-1.91-10.8l.17.12-15.11,2.42-.2,0,0-.19c-1.52-9.09-3.34-20-5.35-32l.3.2-20.62,4.8-10.51,2.43-.25.06-.06-.25c-2.23-9.08-4.31-17.68-5.87-25.61l.26.19-30.69,4.71-.15,0,0-.16c-.59-4.92-1.06-8.81-1.39-11.5-.14-1.32-.26-2.34-.34-3.06,0-.32-.06-.58-.08-.78a.79.79,0,0,1,0-.27s0,.09,0,.26l.12.78.42,3.05c.36,2.69.88,6.57,1.53,11.48l-.17-.13,30.66-4.88.22,0,.05.22c1.58,7.91,3.67,16.51,5.91,25.58l-.31-.19,10.51-2.44L585.32,269l.26-.06,0,.26c2,12,3.75,23,5.24,32l-.22-.16,15.12-2.32.15,0,0,.14c.76,4.63,1.36,8.3,1.77,10.82.2,1.24.35,2.19.45,2.87.05.31.08.55.11.74A.94.94,0,0,1,608.29,313.57Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M611.67,292.68a1.23,1.23,0,0,1-.28.11l-.83.25c-.72.24-1.81.48-3.17,1a65.41,65.41,0,0,0-11.12,5,77.75,77.75,0,0,0-14.58,10.61,100.54,100.54,0,0,0-14.49,16.67,149,149,0,0,0-11.09,19.16c-3,6.11-5.42,11.76-7.38,16.53s-3.48,8.66-4.54,11.34c-.53,1.31-.94,2.35-1.24,3.09-.13.32-.24.59-.33.79a1.53,1.53,0,0,1-.13.27,1.33,1.33,0,0,1,.08-.29c.07-.21.17-.48.29-.81q.4-1.12,1.14-3.12c1-2.71,2.48-6.61,4.39-11.41s4.3-10.46,7.29-16.61A146.94,146.94,0,0,1,566.78,326a98.83,98.83,0,0,1,14.59-16.73,76.19,76.19,0,0,1,14.72-10.57,60.82,60.82,0,0,1,11.24-4.82c1.37-.47,2.48-.68,3.21-.89l.84-.2A1.82,1.82,0,0,1,611.67,292.68Z",
    style: {
      fill: "#263238"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Notes--inject-17"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M294.22,204l.14,2.69a2.31,2.31,0,0,1,3.91,1.58,2.31,2.31,0,0,1-3.72,2l.15,2.7a2.26,2.26,0,0,1,1.47-.64,2.34,2.34,0,0,1,.25,4.68,2.32,2.32,0,0,1-1.53-.48l.14,2.7a2.31,2.31,0,0,1,1.47-.64,2.34,2.34,0,0,1,.25,4.67,2.29,2.29,0,0,1-1.53-.47l.15,2.7a2.26,2.26,0,0,1,1.47-.64,2.34,2.34,0,0,1,.25,4.67,2.26,2.26,0,0,1-1.53-.48l.14,2.71a2.34,2.34,0,1,1,.19,3.55l.15,2.71a2.26,2.26,0,0,1,1.47-.64,2.34,2.34,0,0,1,.25,4.67,2.26,2.26,0,0,1-1.53-.48l.09,1.68,72.09-1.73-3.65-42Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M292.62,202.22l.15,2.7a2.28,2.28,0,0,1,1.47-.64,2.34,2.34,0,1,1-1.28,4.19l.14,2.7a2.31,2.31,0,0,1,3.91,1.58,2.31,2.31,0,0,1-3.72,2l.15,2.7a2.28,2.28,0,0,1,1.47-.64,2.34,2.34,0,1,1-1.28,4.2l.14,2.7a2.31,2.31,0,0,1,1.47-.64,2.34,2.34,0,0,1,.25,4.67,2.29,2.29,0,0,1-1.53-.47l.15,2.7a2.28,2.28,0,0,1,1.47-.64,2.34,2.34,0,0,1,.25,4.67,2.28,2.28,0,0,1-1.53-.48l.14,2.71a2.34,2.34,0,1,1,.19,3.55l.09,1.68,72.08-3.85-2.1-39.23Z",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M365.11,206.12c0,.15-16.12,1.12-36,2.19s-36,1.81-36,1.67,16.12-1.13,36-2.19S365.11,206,365.11,206.12Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M365.45,212.4c0,.14-16.12,1.12-36,2.19s-36.05,1.81-36.05,1.66,16.11-1.12,36-2.18S365.44,212.25,365.45,212.4Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M365.79,218.67c0,.15-16.13,1.13-36,2.19s-36,1.81-36.05,1.67,16.12-1.12,36-2.19S365.78,218.53,365.79,218.67Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M366.12,225c0,.14-16.12,1.12-36,2.19s-36.05,1.81-36.05,1.67,16.12-1.13,36-2.19S366.11,224.81,366.12,225Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M366.46,231.23c0,.14-16.12,1.12-36,2.18s-36.05,1.82-36.06,1.67,16.12-1.12,36-2.19S366.45,231.08,366.46,231.23Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 303.44,
    y: 201.65,
    width: 0.5,
    height: 39.28,
    transform: "translate(-11.39 16.54) rotate(-3.06)",
    style: {
      fill: "#E59124"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M311.27,240.56c-.14,0-.73-8.77-1.31-19.6s-.93-19.62-.79-19.63.73,8.77,1.31,19.6S311.42,240.55,311.27,240.56Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M298.44,241.24c-.14,0-.73-8.76-1.31-19.59S296.2,202,296.34,202s.73,8.76,1.31,19.6S298.59,241.24,298.44,241.24Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M318.3,240.18c-.14,0-.73-8.77-1.31-19.6S316.06,201,316.2,201s.73,8.77,1.31,19.61S318.44,240.17,318.3,240.18Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M325.33,239.81c-.15,0-.73-8.77-1.31-19.6s-.93-19.62-.79-19.63.73,8.76,1.31,19.6S325.47,239.8,325.33,239.81Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M332.35,239.43c-.14,0-.72-8.77-1.3-19.6s-.94-19.62-.79-19.63.73,8.77,1.31,19.6S332.5,239.42,332.35,239.43Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M339.38,239.05c-.14,0-.73-8.76-1.31-19.6s-.93-19.62-.79-19.62.73,8.76,1.31,19.6S339.53,239.05,339.38,239.05Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M346.41,238.68c-.14,0-.73-8.77-1.31-19.6s-.93-19.62-.79-19.63.73,8.77,1.31,19.6S346.55,238.67,346.41,238.68Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M353.44,238.3c-.15,0-.73-8.77-1.31-19.6s-.94-19.62-.79-19.63.73,8.77,1.31,19.61S353.58,238.29,353.44,238.3Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M360.46,237.93c-.14,0-.73-8.77-1.31-19.6s-.93-19.62-.79-19.63.73,8.76,1.31,19.6S360.61,237.92,360.46,237.93Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M359.59,214.17a1.68,1.68,0,0,1-.51.08l-1.48.13-5.41.36c-4.58.29-10.91.64-17.89,1s-13.33.61-17.91.75-7.43.16-7.42,0l25.3-1.27,17.9-.83,5.42-.21,1.48,0A1.61,1.61,0,0,1,359.59,214.17Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M361.05,221.34c0,.14-11.63.79-26,1.45s-26,1.08-26,.93,11.62-.79,26-1.45S361,221.19,361.05,221.34Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M361.82,227.61c0,.15-11.62.8-26,1.46s-26,1.07-26,.93,11.62-.8,26-1.45S361.81,227.47,361.82,227.61Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M300.69,206.33a6.3,6.3,0,0,0,2.31,4,4.12,4.12,0,1,0,1.51-7.43",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M300.52,206.32a3.28,3.28,0,1,0,3.1-3.45A3.28,3.28,0,0,0,300.52,206.32Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M298.63,205.11a2,2,0,0,0,3.93-.21,2,2,0,1,0-3.93.21Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M300.47,206.93c0-.08.31-.06.71-.21a1.9,1.9,0,0,0,1.12-1.08,2,2,0,0,0-.15-1.57c-.2-.39-.43-.57-.39-.64s.36,0,.69.43a2.08,2.08,0,0,1,.34,1.95,2,2,0,0,1-1.52,1.27C300.74,207.16,300.45,207,300.47,206.93Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M302.12,203.8c.07-.13.56,0,1.11-.12s.93-.47,1-.38-.15.7-.93.89S302,203.9,302.12,203.8Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M302.62,208.78c-.14,0-.28-.61-.8-1.09s-1.13-.59-1.13-.73.79-.3,1.49.35S302.76,208.81,302.62,208.78Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M356.09,204a6.33,6.33,0,0,0,2.31,4,4.12,4.12,0,1,0,1.51-7.43",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M362.43,203.13a3.17,3.17,0,1,1-3.34-3A3.17,3.17,0,0,1,362.43,203.13Z",
    style: {
      fill: "#E59124"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M364.11,201.77a1.9,1.9,0,1,1-2-1.8A1.89,1.89,0,0,1,364.11,201.77Z",
    style: {
      fill: "#E59124"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M362.54,203.71s-.24.25-.75.23a1.9,1.9,0,0,1-1.6-1.06,2,2,0,0,1,.12-1.91c.28-.43.6-.54.63-.49s-.15.27-.3.66a1.93,1.93,0,0,0,0,1.51,1.81,1.81,0,0,0,1.18.93C362.24,203.68,362.52,203.63,362.54,203.71Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M360.63,200.87c.11.1-.36.6-1.14.51s-1.11-.69-1-.77.51.2,1.05.26S360.55,200.75,360.63,200.87Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M360.66,205.71c-.14,0-.33-.75.27-1.46s1.42-.63,1.4-.49-.57.31-1,.83S360.81,205.7,360.66,205.71Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "239.72 297.38 298.64 304.89 297.85 283.32 239.72 297.38",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 240.37,
    y: 281.36,
    width: 56.76,
    height: 18.84,
    transform: "translate(25.11 -21.34) rotate(4.77)",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M289.86,289.39c0,.14-9.5-.53-21.19-1.51s-21.15-1.88-21.14-2,9.5.53,21.19,1.5S289.87,289.25,289.86,289.39Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M289.75,294.29c0,.14-9.5-.53-21.19-1.51s-21.15-1.88-21.14-2,9.49.53,21.19,1.5S289.76,294.15,289.75,294.29Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "258.01 277.75 279.93 279.57 278.78 280.55 280.28 281.86 278.49 282.68 280.09 284.1 257.12 282.18 258.55 280.97 257.84 279.67 259.07 279.04 258.01 277.75",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M206.31,243.77a2.55,2.55,0,1,1-4.38,0h-3a2.58,2.58,0,0,1,.36,1.29,2.55,2.55,0,1,1-4.74-1.29h-2.95a2.48,2.48,0,0,1,.36,1.29,2.55,2.55,0,1,1-4.74-1.29h-3a2.48,2.48,0,0,1,.36,1.29,2.55,2.55,0,1,1-5.09,0,2.48,2.48,0,0,1,.36-1.29h-3a2.48,2.48,0,0,1,.36,1.29,2.55,2.55,0,1,1-5.09,0,2.48,2.48,0,0,1,.36-1.29h-3a2.55,2.55,0,1,1-4.38,0h-1.85v52.62l46,2.53-2.2-55.15Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#freepik--clip-path--inject-17)"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M205.64,242.33a2.55,2.55,0,1,1-4.38,0h-2.95a2.58,2.58,0,0,1,.36,1.29,2.55,2.55,0,1,1-4.74-1.29h-3a2.48,2.48,0,0,1,.36,1.29,2.55,2.55,0,1,1-4.74-1.29h-2.95a2.48,2.48,0,0,1,.36,1.29,2.55,2.55,0,1,1-5.09,0,2.48,2.48,0,0,1,.36-1.29h-2.95a2.55,2.55,0,1,1-4.74,1.29,2.48,2.48,0,0,1,.36-1.29H169a2.55,2.55,0,1,1-4.38,0h-1.85V295h43.84V242.33Z",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M160.1,297.38c-.15,0-.39-12.75-.55-28.48s-.18-28.49,0-28.49.39,12.75.55,28.48S160.24,297.38,160.1,297.38Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M167.14,297.31c-.15,0-.4-12.75-.56-28.48s-.17-28.49,0-28.49.39,12.75.55,28.48S167.28,297.31,167.14,297.31Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M170.63,297.31c-.14,0-.39-12.75-.55-28.48s-.18-28.49,0-28.49.39,12.75.55,28.48S170.77,297.31,170.63,297.31Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M177.74,297.31c-.14,0-.39-12.75-.55-28.48s-.17-28.49,0-28.49.39,12.75.55,28.48S177.89,297.31,177.74,297.31Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M184.85,297.31c-.14,0-.39-12.75-.55-28.48s-.17-28.49,0-28.49.39,12.75.55,28.48S185,297.31,184.85,297.31Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M192,297.31c-.14,0-.39-12.75-.55-28.48s-.17-28.49,0-28.49.39,12.75.55,28.48S192.11,297.31,192,297.31Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M198.71,297.31c-.14,0-.39-12.75-.55-28.48s-.17-28.49,0-28.49.39,12.75.55,28.48S198.86,297.31,198.71,297.31Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M205.46,297.31c-.14,0-.39-12.75-.55-28.48s-.18-28.49,0-28.49.39,12.75.55,28.48S205.6,297.31,205.46,297.31Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M174.17,297.24c-.14,0-.39-12.76-.55-28.49s-.17-28.48,0-28.48.39,12.74.55,28.48S174.32,297.23,174.17,297.24Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M181.21,297.16c-.14,0-.39-12.75-.55-28.48s-.18-28.48,0-28.49.39,12.75.55,28.49S181.35,297.16,181.21,297.16Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M188.25,297.09c-.15,0-.4-12.75-.56-28.48s-.17-28.49,0-28.49.39,12.75.55,28.49S188.39,297.09,188.25,297.09Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M195.28,297c-.14,0-.39-12.75-.55-28.48s-.17-28.49,0-28.49.39,12.75.55,28.48S195.43,297,195.28,297Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M202,297.38c-.15,0-.39-12.75-.55-28.48s-.18-28.49,0-28.49.39,12.75.55,28.48S202.17,297.38,202,297.38Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M209.36,296.88c-.15,0-.39-12.76-.56-28.49s-.17-28.48,0-28.48.39,12.74.56,28.48S209.5,296.87,209.36,296.88Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M216.91,290.2c0,.14-12.76.39-28.48.54s-28.49.17-28.49,0,12.75-.39,28.48-.55S216.9,290.06,216.91,290.2Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M217.2,293.8c0,.14-12.75.39-28.48.54s-28.49.17-28.49,0,12.75-.39,28.49-.55S217.2,293.65,217.2,293.8Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M216.84,283.16c0,.15-12.76.39-28.48.55s-28.49.17-28.49,0,12.75-.39,28.48-.54S216.83,283,216.84,283.16Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M216.77,276.13c0,.14-12.76.38-28.49.54s-28.48.17-28.48,0,12.75-.38,28.48-.54S216.76,276,216.77,276.13Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M216.7,269.09c0,.14-12.76.39-28.49.54s-28.48.17-28.48,0,12.74-.39,28.48-.55S216.69,268.94,216.7,269.09Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M216.63,262.05c0,.15-12.76.39-28.49.55s-28.48.16-28.48,0,12.74-.39,28.48-.54S216.62,261.91,216.63,262.05Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M216.55,255c0,.15-12.75.39-28.48.55s-28.48.17-28.48,0,12.74-.38,28.48-.54S216.55,254.87,216.55,255Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M216.48,248c0,.14-12.75.39-28.48.54s-28.48.17-28.49,0,12.75-.39,28.49-.55S216.48,247.83,216.48,248Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M216.48,245.16c0,.14-12.75.39-28.48.54s-28.48.17-28.49,0,12.75-.39,28.49-.55S216.48,245,216.48,245.16Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M216.48,251.57c0,.15-12.75.39-28.48.55s-28.48.17-28.49,0,12.75-.39,28.49-.54S216.48,251.43,216.48,251.57Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M216.48,258.55c0,.15-12.75.39-28.48.55s-28.48.17-28.49,0,12.75-.38,28.49-.54S216.48,258.41,216.48,258.55Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M216.48,265.53c0,.15-12.75.39-28.48.55s-28.48.17-28.49,0,12.75-.38,28.49-.54S216.48,265.39,216.48,265.53Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M216.48,272.52c0,.14-12.75.38-28.48.54s-28.48.17-28.49,0,12.75-.38,28.49-.54S216.48,272.37,216.48,272.52Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M216.48,279.5c0,.14-12.75.38-28.48.54s-28.48.17-28.49,0,12.75-.39,28.49-.55S216.48,279.35,216.48,279.5Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M216.48,286.48c0,.14-12.75.38-28.48.54s-28.48.17-28.49,0,12.75-.39,28.49-.55S216.48,286.33,216.48,286.48Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M205.64,242.33a2.55,2.55,0,1,1-4.38,0h-2.95a2.58,2.58,0,0,1,.36,1.29,2.55,2.55,0,1,1-4.74-1.29h-3a2.48,2.48,0,0,1,.36,1.29,2.55,2.55,0,1,1-4.74-1.29h-2.95a2.48,2.48,0,0,1,.36,1.29,2.55,2.55,0,1,1-5.09,0,2.48,2.48,0,0,1,.36-1.29h-2.95a2.55,2.55,0,1,1-4.74,1.29,2.48,2.48,0,0,1,.36-1.29H169a2.55,2.55,0,1,1-4.38,0h-1.85V295h43.84V242.33Z",
    style: {
      fill: "none"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M181.68,250a6.3,6.3,0,0,0,2.31,4,4.12,4.12,0,1,0,1.51-7.43",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M181.6,249.94a3.28,3.28,0,1,0,3.1-3.45A3.28,3.28,0,0,0,181.6,249.94Z",
    style: {
      fill: "#E59124"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M179.72,248.73a2,2,0,1,0,1.86-2.07A2,2,0,0,0,179.72,248.73Z",
    style: {
      fill: "#E59124"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M181.55,250.55c0-.08.31-.05.71-.2a1.92,1.92,0,0,0,1.12-1.09,2,2,0,0,0-.15-1.57c-.2-.38-.43-.57-.39-.63s.36,0,.69.42a2.08,2.08,0,0,1,.34,2,2,2,0,0,1-1.52,1.27C181.83,250.78,181.53,250.6,181.55,250.55Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M183.2,247.42c.07-.13.56,0,1.11-.11s.93-.47,1.05-.39-.15.71-.93.89S183.11,247.53,183.2,247.42Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M183.7,252.4c-.14,0-.28-.61-.79-1.09s-1.14-.59-1.14-.73.79-.29,1.49.35S183.85,252.43,183.7,252.4Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M201.7,261.13c0,.14-7,.26-15.62.26s-15.63-.12-15.63-.26,7-.26,15.63-.26S201.7,261,201.7,261.13Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M201.7,264.38c0,.14-7,.26-15.62.26s-15.63-.12-15.63-.26,7-.26,15.63-.26S201.7,264.23,201.7,264.38Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M201.7,267.63c0,.14-7,.26-15.62.26s-15.63-.12-15.63-.26,7-.26,15.63-.26S201.7,267.48,201.7,267.63Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M201.7,270.87c0,.15-7,.26-15.62.26s-15.63-.11-15.63-.26,7-.26,15.63-.26S201.7,270.73,201.7,270.87Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M201.7,274.12c0,.15-7,.26-15.62.26s-15.63-.11-15.63-.26,7-.26,15.63-.26S201.7,274,201.7,274.12Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M201.7,277.37c0,.14-7,.26-15.62.26s-15.63-.12-15.63-.26,7-.26,15.63-.26S201.7,277.23,201.7,277.37Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M201.7,280.62c0,.14-7,.26-15.62.26s-15.63-.12-15.63-.26,7-.26,15.63-.26S201.7,280.47,201.7,280.62Z",
    style: {
      fill: "#263238"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Lamp--inject-17"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M124.53,430.15a1.06,1.06,0,0,1-1-.8L87.94,293.85a1.06,1.06,0,1,1,2.06-.54l35.56,135.5a1.06,1.06,0,0,1-.76,1.3A.84.84,0,0,1,124.53,430.15Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M115.13,433.5a1.06,1.06,0,0,1-1-.79L78.55,297.2a1.06,1.06,0,1,1,2.06-.54l35.56,135.51a1.06,1.06,0,0,1-.76,1.3A1.33,1.33,0,0,1,115.13,433.5Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "82.82 291.32 81.11 290.05 172.4 167.19 255.67 183.15 255.27 185.24 173.31 169.53 82.82 291.32",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 59.29,
    y: 231.28,
    width: 150.91,
    height: 2.13,
    transform: "translate(-132.16 202.38) rotate(-53.48)",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M170.13,172.83a6,6,0,1,0,3.77-7.66A6,6,0,0,0,170.13,172.83Z",
    style: {
      fill: "#E59124"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "251.74 176.28 250.25 167.6 256.67 167.12 257.14 175.5 251.74 176.28",
    style: {
      fill: "#E59124"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.30000000000000004
    }
  }, _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    points: "251.74 176.28 250.25 167.6 256.67 167.12 257.14 175.5 251.74 176.28"
  }))), /*#__PURE__*/React.createElement("polyline", {
    points: "246.48 175.68 240.54 207.88 225.54 250.43 310.08 238.24 275.96 201.09 261.71 173.48 246.48 175.68",
    style: {
      fill: "#E59124"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M76.9,294.92a6.71,6.71,0,1,0,6.71-6.71A6.71,6.71,0,0,0,76.9,294.92Z",
    style: {
      fill: "#E59124"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M97.76,457.26c0-.45-.07-.89-.07-1.35a26.84,26.84,0,0,1,53.67,0c0,.46-.05.9-.07,1.35Z",
    style: {
      fill: "#E59124"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Character--inject-17"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M244.12,447.21c-.33.07-1.74,1.5.27,3.77s14.13,8.48,16.36,4.77-3.15-6.29-3.15-6.29Z",
    style: {
      fill: "#ffbe9d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M257.43,443.21s12.5-1.38,17.6-.73c5.53.71,11.4-2.08,14.88-5.9a20,20,0,0,0,4.39-8.84l8-5.56s.86-18.91-11.75-15.86l-14.73.52s-29,4.8-33.48,8.41c0,0-5.46,5.31-7.05,7.36-.6.78-1.11,8.57,4.43,11.23,0,0-3.27,4.17-.39,6.53l1.35,1s-1.87,4.17-.11,5.36,15.67,5.41,19.62,2.66-.63-5.92-2.72-6.2",
    style: {
      fill: "#ffbe9d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M241.85,433.1a12.58,12.58,0,0,1,1.63.18c1.05.13,2.57.32,4.46.46.94.06,2,.12,3.08.14s2.29,0,3.56.09a7.32,7.32,0,0,1,3.83,1.21,4.24,4.24,0,0,1,1.87,3.85,3.27,3.27,0,0,1-1.12,2,5.62,5.62,0,0,1-1.89,1.05,17.07,17.07,0,0,1-3.91.73,35.26,35.26,0,0,1-6.69-.13c-1.89-.2-3.4-.45-4.44-.63a9,9,0,0,1-1.62-.34,11.44,11.44,0,0,1,1.64.14c1.06.12,2.58.31,4.46.46a37.93,37.93,0,0,0,6.6,0,17.13,17.13,0,0,0,3.79-.73,5.37,5.37,0,0,0,1.72-.95,2.8,2.8,0,0,0,.94-1.67,3.75,3.75,0,0,0-1.65-3.37,7.08,7.08,0,0,0-3.57-1.15c-1.22-.11-2.42-.07-3.53-.13s-2.16-.11-3.11-.21c-1.89-.18-3.4-.42-4.45-.62A8,8,0,0,1,241.85,433.1Z",
    style: {
      fill: "#eb996e"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M240.83,424.07a10.53,10.53,0,0,1,1.63.18c1,.14,2.56.34,4.43.5s4.11.29,6.6.29a8.84,8.84,0,0,1,3.95.59,3.15,3.15,0,0,1,1.5,1.61,4.07,4.07,0,0,1,.21,2.24,5.38,5.38,0,0,1-2.53,3.47,8.68,8.68,0,0,1-3.8,1.23,37.72,37.72,0,0,1-6.65-.31l-4.44-.45a9.48,9.48,0,0,1-1.63-.24,10.75,10.75,0,0,1,1.64,0l4.46.29a41.51,41.51,0,0,0,6.57.19,8.26,8.26,0,0,0,3.58-1.19,4.85,4.85,0,0,0,2.28-3.12,3,3,0,0,0-1.43-3.31,8.38,8.38,0,0,0-3.71-.56c-2.51,0-4.75-.19-6.63-.4s-3.39-.47-4.43-.67A9.29,9.29,0,0,1,240.83,424.07Z",
    style: {
      fill: "#eb996e"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M247.28,425.17a16.38,16.38,0,0,1-1.13-2.31,14.25,14.25,0,0,1-1.2-2.27c.1-.1,1,.72,1.66,2A4.31,4.31,0,0,1,247.28,425.17Z",
    style: {
      fill: "#eb996e"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M285.52,407.08l-11.82-1.57s-33.4-6.81-33.73-5.93-2,1.19-.74,4.77,20.51,6.75,21.37,7.89,1.48,7.77,9,10.82,12.26,2,12.26,2",
    style: {
      fill: "#ffbe9d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M281.9,425.08l-.25.07-.77.11a18,18,0,0,1-3,0,26.12,26.12,0,0,1-4.63-.82,25.51,25.51,0,0,1-5.81-2.26,13.5,13.5,0,0,1-5.21-5.44,30.49,30.49,0,0,1-1.6-3.89,3.61,3.61,0,0,0-.22-.44,1.06,1.06,0,0,0-.35-.22,10.18,10.18,0,0,0-1-.35c-.7-.22-1.42-.41-2.16-.6-2.94-.77-6.05-1.51-9.23-2.44-1.59-.47-3.2-1-4.8-1.63a16,16,0,0,1-2.35-1.16,5.68,5.68,0,0,1-1.08-.85,2.41,2.41,0,0,1-.41-.61c-.11-.23-.14-.44-.22-.65a4.86,4.86,0,0,1-.16-2.73,3.21,3.21,0,0,1,.72-1.18,2.24,2.24,0,0,0,.33-.46s0,0,.08-.13a.35.35,0,0,1,.19-.12,1.12,1.12,0,0,1,.22,0h.35c1.74.11,3.39.4,5,.66,3.27.54,6.41,1.12,9.4,1.69,6,1.13,11.34,2.21,15.85,3.14,1.12.22,2.2.48,3.21.65l2.9.4,4.63.66,2.93.44.76.13.26.06a.79.79,0,0,1-.27,0l-.76-.07-2.95-.35-4.65-.57-2.91-.37c-1-.16-2.09-.4-3.22-.61l-15.87-3c-3-.55-6.13-1.13-9.39-1.66-1.63-.25-3.31-.54-5-.65h-.3l-.1,0s0,0,0,0,0-.08-.05-.12l0,0c.39.14.1,0,.19.09l0,0a2.05,2.05,0,0,1-.41.59,2.77,2.77,0,0,0-.62,1,4.4,4.4,0,0,0,.17,2.42,2.25,2.25,0,0,0,.52,1.06,5.26,5.26,0,0,0,1,.76,16.5,16.5,0,0,0,2.27,1.12c1.57.64,3.16,1.15,4.75,1.62,3.16.94,6.26,1.68,9.2,2.46.74.2,1.47.4,2.18.62a8.39,8.39,0,0,1,1.06.38,1.25,1.25,0,0,1,.54.38,2.41,2.41,0,0,1,.27.53,30.17,30.17,0,0,0,1.57,3.86,13.06,13.06,0,0,0,5,5.32,25.58,25.58,0,0,0,5.7,2.3,26.29,26.29,0,0,0,4.57.89,20.21,20.21,0,0,0,2.94.1c.34,0,.6,0,.77,0Z",
    style: {
      fill: "#eb996e"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M253.79,442.62a3.85,3.85,0,0,1,1.23.06,11.81,11.81,0,0,1,3.22.95,10.6,10.6,0,0,1,2,1.2,3.56,3.56,0,0,1,1.48,2.32,2.87,2.87,0,0,1-1.48,2.64,5.55,5.55,0,0,1-3.18.66,59.63,59.63,0,0,1-10.91-1.61c-1.37-.35-2.46-.71-3.2-1a5.66,5.66,0,0,1-1.13-.49,5.73,5.73,0,0,1,1.19.29c.76.22,1.85.52,3.22.82a70.77,70.77,0,0,0,10.85,1.45,5.12,5.12,0,0,0,2.89-.57,2.39,2.39,0,0,0,1.27-2.17,3.13,3.13,0,0,0-1.27-2,10,10,0,0,0-1.91-1.2A17.46,17.46,0,0,0,253.79,442.62Z",
    style: {
      fill: "#eb996e"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M340.74,374.35s14.81-24.38,18.14-40.47S379.41,292.26,385,285.6s27.75-14.42,27.75-14.42l8.18-4.42,63.39-5.57s42.17,4.44,54.94,16.09S562,315.57,562,328.88s12.89,128.64,12.89,128.64l-156.21-.2,3.5-56.86s-18.87-12.76-23.86-23.86-2.22-5.55-2.22-5.55-17.71,37.65-23.81,42.09-77.05,26.21-77.05,26.21l-9.71-37.23Z",
    style: {
      fill: "#E59124"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M525.17,281.93c-1.71.53-22.87,55.18-24.36,60.15s0,36.29,0,36.29l7,12.93s-2,9.44-.5,13.92l-31.32,6s-7.95-5.47-15.41,0l-37,3.13s10.85.12,7.62,16.76c-3.16,16.3-5.57,19.88-5.57,19.88l129.85-3s14.43-.72,12.23-28.46-8.39-104.26-8.39-104.26S549.86,274.27,525.17,281.93Z",
    style: {
      fill: "#E59124"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M500.52,374a2.88,2.88,0,0,1-.31-.67l-.79-2c-.34-.85-.75-1.9-1.15-3.15s-.93-2.64-1.35-4.23-1-3.32-1.39-5.21-.86-3.91-1.26-6a110.52,110.52,0,0,1-1.53-14.09,113.38,113.38,0,0,1,.43-14.17c.26-2.16.47-4.22.82-6.13.16-1,.29-1.88.47-2.77s.36-1.72.53-2.53c.32-1.61.73-3,1.06-4.32s.64-2.34.93-3.22.49-1.5.65-2a7.27,7.27,0,0,1,.26-.7,3,3,0,0,1-.16.73c-.14.51-.33,1.19-.56,2s-.56,2-.84,3.24-.69,2.7-1,4.32c-.16.81-.32,1.65-.49,2.53s-.29,1.8-.44,2.75c-.33,1.91-.53,4-.77,6.12a106.24,106.24,0,0,0,1.09,28.12c.39,2.14.75,4.17,1.21,6s.89,3.62,1.32,5.21.9,3,1.28,4.24.75,2.31,1.06,3.17l.7,2A6,6,0,0,1,500.52,374Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M545.7,433.27s-.13-.12-.34-.38l-.86-1.15c-.37-.51-.83-1.12-1.39-1.8s-1.17-1.49-1.92-2.32-1.54-1.76-2.46-2.69-1.92-1.92-3-2.93a74.19,74.19,0,0,0-7.48-6,75,75,0,0,0-8.24-4.88c-1.33-.64-2.58-1.27-3.8-1.76s-2.34-1-3.38-1.35-2-.69-2.85-1-1.57-.5-2.17-.66l-1.38-.41a1.81,1.81,0,0,1-.48-.18,2.22,2.22,0,0,1,.5.08l1.41.31c.61.14,1.35.32,2.21.58s1.83.52,2.88.92,2.22.77,3.43,1.29,2.5,1.1,3.84,1.73a69.18,69.18,0,0,1,8.33,4.88,71.26,71.26,0,0,1,7.5,6.06c1.07,1,2.09,2,3,3s1.71,1.89,2.43,2.75,1.32,1.68,1.87,2.38,1,1.34,1.32,1.86.58.88.79,1.21A2.06,2.06,0,0,1,545.7,433.27Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M556.63,426c-.08.07-1.23-1.24-3.39-3a34.36,34.36,0,0,0-4-2.8,38.09,38.09,0,0,0-5.39-2.61,37.65,37.65,0,0,0-5.76-1.62,34.71,34.71,0,0,0-4.86-.57c-2.79-.11-4.52.1-4.53,0a5.38,5.38,0,0,1,1.21-.2,12.36,12.36,0,0,1,1.43-.13c.56,0,1.19-.07,1.9,0a31.83,31.83,0,0,1,4.94.47,34.63,34.63,0,0,1,5.85,1.61,34.26,34.26,0,0,1,5.46,2.68,31.57,31.57,0,0,1,4,2.92c.55.45,1,.91,1.39,1.3a11.24,11.24,0,0,1,1,1A5.6,5.6,0,0,1,556.63,426Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M544.62,407.71c-.06.09-1.59-1.13-4.39-2.51a22.74,22.74,0,0,0-2.34-1c-.84-.36-1.78-.63-2.76-.94a31.66,31.66,0,0,0-13.27-.91c-1,.17-2,.31-2.86.55a23.71,23.71,0,0,0-2.46.7c-3,1-4.64,2-4.69,1.88a6.53,6.53,0,0,1,1.17-.71,11.78,11.78,0,0,1,1.43-.72,20.53,20.53,0,0,1,2-.8,21.31,21.31,0,0,1,2.47-.76,27.81,27.81,0,0,1,2.9-.62,30.48,30.48,0,0,1,13.47.93,24.42,24.42,0,0,1,2.79,1,20.73,20.73,0,0,1,2.35,1.09,19.62,19.62,0,0,1,1.84,1.07,10.62,10.62,0,0,1,1.32.9A5.79,5.79,0,0,1,544.62,407.71Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M468.68,448.69a46.75,46.75,0,0,0,.92-5.56,35.92,35.92,0,0,0-.05-6.11,48.76,48.76,0,0,0-1.3-7.37,51.67,51.67,0,0,0-2.49-7,38.66,38.66,0,0,0-3-5.34,51,51,0,0,0-3.53-4.41,9.57,9.57,0,0,1,1.15,1,12.77,12.77,0,0,1,1.22,1.32l.72.85c.25.32.48.66.74,1a34.64,34.64,0,0,1,3.1,5.35A43.24,43.24,0,0,1,470,437a33.82,33.82,0,0,1-.06,6.18c-.05.44-.1.85-.14,1.25l-.22,1.1a11.43,11.43,0,0,1-.42,1.74A9.53,9.53,0,0,1,468.68,448.69Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M446.91,411.16a1,1,0,0,1-.06-.29c0-.22-.08-.5-.14-.85-.11-.79-.27-1.89-.47-3.29-.41-2.86-.94-7-1.56-12.14-1.23-10.25-2.7-24.45-3.85-40.17s-1.75-30-2-40.31c-.14-5.16-.21-9.34-.23-12.23,0-1.41,0-2.53,0-3.32v-.87a.15.15,0,1,1,.06,0c0,.23,0,.51,0,.87,0,.79.06,1.9.11,3.32.09,2.92.22,7.09.38,12.22.37,10.32,1,24.57,2.17,40.29s2.56,29.9,3.7,40.16c.58,5.1,1.06,9.24,1.39,12.15.16,1.41.28,2.51.37,3.31,0,.35.07.63.09.86A1.59,1.59,0,0,1,446.91,411.16Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M395.9,371.77a11.41,11.41,0,0,1-.68-1.53c-.4-1-1-2.43-1.75-4.2-1.5-3.53-3.74-8.34-6.42-13.56s-5.1-9.85-6.91-13.33c-.87-1.72-1.57-3.11-2-4.08a10.92,10.92,0,0,1-.67-1.54,9.27,9.27,0,0,1,.85,1.44l2.17,4c1.82,3.38,4.38,8,7.06,13.27s4.87,10.07,6.29,13.65c.71,1.79,1.26,3.25,1.6,4.27A10.61,10.61,0,0,1,395.9,371.77Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M387.92,353.29a3.06,3.06,0,0,1-.91-.17c-.57-.14-1.39-.38-2.4-.71a59.23,59.23,0,0,1-14.78-7.32c-.87-.6-1.56-1.11-2-1.48a3.56,3.56,0,0,1-.68-.61,32.61,32.61,0,0,1,2.91,1.78c1.78,1.12,4.28,2.59,7.16,4s5.56,2.52,7.53,3.26A33.85,33.85,0,0,1,387.92,353.29Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M374.51,387.44a5.39,5.39,0,0,1-1.08-.65c-.66-.45-1.64-1.09-2.87-1.83a59.14,59.14,0,0,0-20.91-7.83c-1.42-.25-2.57-.41-3.37-.51a5.5,5.5,0,0,1-1.24-.21,5.54,5.54,0,0,1,1.26,0c.8,0,2,.14,3.41.34a52.55,52.55,0,0,1,11,2.8,53.17,53.17,0,0,1,10.1,5.08c1.21.8,2.16,1.48,2.79,2A6.85,6.85,0,0,1,374.51,387.44Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M482.63,261.28a8.06,8.06,0,0,1-.06.81c-.07.58-.16,1.35-.27,2.32-.26,2-.62,4.92-1.23,8.5a107.72,107.72,0,0,1-2.8,12.44A58,58,0,0,1,472,299.63a43.78,43.78,0,0,1-5.21,6.68l-.2.22-.19-.25a26.45,26.45,0,0,0-9.49-7.87,25.22,25.22,0,0,0-5-1.84,22.13,22.13,0,0,0-4.55-.61,18.77,18.77,0,0,0-6.48.91c-1.45.51-2.22.89-2.24.84a3.6,3.6,0,0,1,.55-.29,13.55,13.55,0,0,1,1.63-.72,18.16,18.16,0,0,1,6.55-1.07,22.09,22.09,0,0,1,4.64.56,25.49,25.49,0,0,1,5.1,1.82,26.65,26.65,0,0,1,9.7,8l-.39,0a44.48,44.48,0,0,0,5.14-6.6,58.91,58.91,0,0,0,6.27-14.14,117.36,117.36,0,0,0,2.9-12.36c.66-3.56,1.07-6.47,1.39-8.47.15-1,.28-1.73.37-2.3A3.56,3.56,0,0,1,482.63,261.28Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "483.48 261.91 473.85 249.14 463.38 249.47 429.36 267.44 483.48 261.91",
    style: {
      fill: "#E59124"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M438.62,297.71a2.3,2.3,0,0,1-.55,0,12.18,12.18,0,0,1-1.57-.26,19.49,19.49,0,0,1-5.37-2.3,11.78,11.78,0,0,0-3.65-1.51,10.75,10.75,0,0,0-4.52,0,10.57,10.57,0,0,0-7.55,6.57l-.54,1.46,0-1.56c0-.39,0-.8,0-1.22.12-7.88.13-15,.45-20.19.15-2.58.35-4.67.57-6.1.09-.72.2-1.27.28-1.64a3.44,3.44,0,0,1,.14-.56c.05,0-.09.79-.22,2.23s-.3,3.51-.4,6.09c-.23,5.16-.17,12.29-.3,20.18,0,.42,0,.84,0,1.23l-.5-.1a11,11,0,0,1,7.94-6.85,11.22,11.22,0,0,1,8.44,1.67,21.13,21.13,0,0,0,5.24,2.42C437.86,297.61,438.63,297.66,438.62,297.71Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M473.85,187.3V264a18.6,18.6,0,0,1-4.37,12h0a56.45,56.45,0,0,1-15.4,12.75l-15.46,8.71L425.82,286a18.63,18.63,0,0,1-6.19-13.15c-.22-5.58-.22-11.21-.22-11.21s-21.67-1.56-23.71-22.93c-1-10.06-1.26-30.67-1.31-49.67a41.58,41.58,0,0,1,38.15-41.53l.61-.05A39.74,39.74,0,0,1,473.85,187.3Z",
    style: {
      fill: "#ffbe9d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M419.35,261.32s13.61,0,27.24-10.24c0,0-5.32,15.94-26.83,15.78Z",
    style: {
      fill: "#eb996e"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M401.59,203.39a3.07,3.07,0,0,0,3.2,2.84,2.93,2.93,0,0,0,2.92-3,3.06,3.06,0,0,0-3.19-2.84A2.93,2.93,0,0,0,401.59,203.39Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M399.85,197.65c.41.36,2.58-1.54,5.87-1.8s5.84,1.18,6.16.75c.16-.2-.28-.88-1.4-1.56a8.37,8.37,0,0,0-5-1.09,8,8,0,0,0-4.63,1.93C399.93,196.74,399.65,197.48,399.85,197.65Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M432.87,202.06a3.07,3.07,0,0,0,3.2,2.84,2.94,2.94,0,0,0,2.93-3,3.07,3.07,0,0,0-3.2-2.84A2.94,2.94,0,0,0,432.87,202.06Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M432.22,195.59c.41.36,2.59-1.54,5.87-1.8s5.84,1.18,6.16.74c.16-.19-.28-.88-1.4-1.55a8.44,8.44,0,0,0-5-1.1,8.06,8.06,0,0,0-4.63,1.93C432.3,194.67,432,195.42,432.22,195.59Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M422.3,221c0-.19-2.07-.38-5.42-.53-.84,0-1.65-.11-1.84-.67a4.32,4.32,0,0,1,.35-2.54c.63-2.1,1.28-4.29,2-6.6,2.69-9.39,4.57-17.08,4.19-17.18s-2.87,7.42-5.56,16.8c-.65,2.32-1.27,4.52-1.85,6.63a4.83,4.83,0,0,0-.16,3.33,2.1,2.1,0,0,0,1.48,1.12,5.65,5.65,0,0,0,1.44.08C420.24,221.3,422.31,221.14,422.3,221Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M432.17,222.43c-.54,0-.25,3.58-3.1,6.37s-6.67,2.71-6.66,3.21c0,.22.91.62,2.52.53a8.89,8.89,0,0,0,5.57-2.48,7.72,7.72,0,0,0,2.37-5.32C432.88,223.24,432.41,222.39,432.17,222.43Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M430.3,182.77c.4.87,3.65.17,7.54.32s7.11.94,7.55.09c.2-.4-.41-1.19-1.74-2a13.14,13.14,0,0,0-11.5-.31C430.78,181.6,430.13,182.36,430.3,182.77Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M400.27,188c.64.7,2.84-.26,5.56-.52s5.07.08,5.54-.74c.2-.4-.22-1.12-1.29-1.74a7.76,7.76,0,0,0-4.63-.85,7.64,7.64,0,0,0-4.31,1.87C400.24,186.89,400,187.69,400.27,188Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M448.68,165.76l.12.08A16.93,16.93,0,0,1,456,176.21l.09.43c1.34,6,1.71,12.25,3.11,18.27s1.14,10.62,7.17,12a8,8,0,0,0,8.39-3.41,5.14,5.14,0,0,0,.53-2.86c-.07-14.82,2.91-20.58,1.6-36a13,13,0,0,0-6.26-10.12c-3.42-2.05-7.56-4.12-11-2.13s-7.53,9.09-10.08,12.17",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M467.43,197.57c.36-.18,14.34-5.56,15.09,9.11s-14.14,12.38-14.18,12S467.43,197.57,467.43,197.57Z",
    style: {
      fill: "#ffbe9d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M472.54,212.86c.06-.05.26.17.7.34a2.54,2.54,0,0,0,1.91-.06c1.52-.64,2.7-3.17,2.64-5.82a8.41,8.41,0,0,0-.9-3.62,2.94,2.94,0,0,0-2-1.86,1.29,1.29,0,0,0-1.47.78c-.18.42-.07.7-.15.73s-.32-.23-.24-.84a1.68,1.68,0,0,1,.53-.95,2,2,0,0,1,1.4-.44,3.6,3.6,0,0,1,2.78,2.14,8.63,8.63,0,0,1,1.09,4c.06,3-1.31,5.8-3.4,6.52a2.73,2.73,0,0,1-2.36-.27C472.58,213.21,472.49,212.89,472.54,212.86Z",
    style: {
      fill: "#eb996e"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M460.27,154.6c3.12-6.15-7.44-13.74-14.85-15.42s-16.63,2.63-23.61,5.61c-4.41,1.88-8.75,4.35-13.54,4.54-3.21.14-6.36-.77-9.47-1.59s-6.33-1.56-9.51-1.07-6.33,2.45-7.29,5.52,1.1,7,4.31,7.16c-4.23-1.89-9.85,1.51-10.12,6.14s4.88,8.68,9.31,7.33c-2.21-1.41-5.19,1.46-4.71,4s3,4.28,5.45,5.13c6.33,2.17,13.37.73,19.51-1.92s11.71-6.44,17.78-9.24,16.22-7.76,22.68-6.07c4.76,1.25,8.44,6.56,11,5.11a9,9,0,0,0,4.08-7,25.7,25.7,0,0,0-1-8.3",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M384.51,159.09c.12-.08.84,1,2.56,2.6a20.21,20.21,0,0,0,8.56,4.55,18.59,18.59,0,0,0,13.9-1.71c4.79-2.64,8.68-7.46,13.23-12.06s10.05-8.26,15.79-9.26,11.18.64,14.38,3.68a12.85,12.85,0,0,1,4.11,9.18,10.18,10.18,0,0,1-.41,2.75c-.22.59-.36.89-.41.87a22.82,22.82,0,0,0,.25-3.6,12.63,12.63,0,0,0-4.22-8.44c-3-2.7-8.14-4.15-13.46-3.13s-10.57,4.44-15,9-8.47,9.45-13.6,12.21a20,20,0,0,1-23.51-3.61,14.32,14.32,0,0,1-1.71-2.15C384.62,159.41,384.47,159.12,384.51,159.09Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M471.11,196.63c-.05.05-.67-.35-1.32-1.47a9.84,9.84,0,0,1-1.16-5.24c-.07-4.74,3.68-10.14,3.67-16.69a14.76,14.76,0,0,0-2.34-8.6,11.28,11.28,0,0,0-5.83-4.25,9.54,9.54,0,0,0-4.94-.26c-1.16.29-1.76.61-1.83.5s.48-.56,1.67-1a9.24,9.24,0,0,1,5.38-.19,11.89,11.89,0,0,1,6.64,4.47,15.57,15.57,0,0,1,2.7,9.38,26.72,26.72,0,0,1-2.06,9.45,27.91,27.91,0,0,0-2,7.29C469.23,194.33,471.31,196.54,471.11,196.63Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 468.76,
    y: 201.98,
    width: 7.53,
    height: 17.43,
    rx: 2.14,
    transform: "translate(269.11 -265.01) rotate(42.82)",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M562.06,332.17s0,.2.06.59.07,1,.13,1.72c.11,1.53.26,3.78.47,6.7.4,5.88,1,14.47,1.71,25.36S566,390.62,567,405.69q.36,5.65.76,11.65c.15,2,.23,4,.32,6.1a29.36,29.36,0,0,1,0,3.11,30.22,30.22,0,0,1-.17,3.15l-.39,3.18c-.23,1.05-.46,2.11-.68,3.17s-.66,2.08-1,3.13-.84,2.05-1.38,3c-2.1,3.89-5.37,7.53-9.91,9h-.06l-97.83,0-31,0h-.34l.09-.33c.95-3.38,1.89-6.72,2.82-10.05q.71-2.49,1.39-5a34.53,34.53,0,0,0,1.16-4.93,21.43,21.43,0,0,0-.86-9.82,12,12,0,0,0-2.34-4.22,6.88,6.88,0,0,0-4-2.35l-2.05-.32,2-.17,36.95-3.1-.11,0a12.62,12.62,0,0,1,8-2.45,16,16,0,0,1,7.71,2.46l-.17,0L507.24,405l-.14.24a13.13,13.13,0,0,1-.54-3.69,30.1,30.1,0,0,1,.1-3.57,55.29,55.29,0,0,1,.95-6.76v.12c-2.51-4.69-4.81-9-6.94-12.94v-.06c-.49-11.53-.67-20.62-.58-26.82,0-3.1.15-5.48.31-7.08a12.1,12.1,0,0,1,.27-1.8c.09-.4.14-.6.14-.6s0,.21-.1.61a13.3,13.3,0,0,0-.23,1.8c-.14,1.6-.23,4-.24,7.07,0,6.2.18,15.29.71,26.81v-.06c2.13,3.95,4.45,8.23,7,12.91l0,0v.06A56.51,56.51,0,0,0,507,398a29.73,29.73,0,0,0-.09,3.54,12.88,12.88,0,0,0,.53,3.58l.06.2-.2,0-31.32,6-.08,0-.08-.05a15.45,15.45,0,0,0-7.48-2.36,12.08,12.08,0,0,0-7.67,2.37l-.06,0h-.06l-36.94,3.14v-.49a7.33,7.33,0,0,1,4.32,2.5,12.61,12.61,0,0,1,2.44,4.4,21.89,21.89,0,0,1,.89,10.05,34.24,34.24,0,0,1-1.17,5q-.69,2.48-1.39,5-1.4,5-2.81,10l-.25-.33,31,0,97.83.07h0a15,15,0,0,0,5.67-3.5,21.12,21.12,0,0,0,3.95-5.29c.53-1,.91-2,1.36-3s.68-2.06,1-3.09.45-2.09.68-3.13.26-2.11.39-3.15a29.82,29.82,0,0,0,.18-3.12,29,29,0,0,0,0-3.09c-.09-2.05-.16-4.07-.31-6.07q-.37-6-.74-11.66c-1-15.07-1.79-28.27-2.48-39.17s-1.21-19.48-1.58-25.36c-.17-2.92-.31-5.18-.4-6.71,0-.75-.07-1.32-.09-1.72S562.06,332.17,562.06,332.17Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M533.74,277.68a19.14,19.14,0,0,1-1.78,1.11,41.65,41.65,0,0,0-4.63,3.32,54.32,54.32,0,0,0-12,14.34,118.46,118.46,0,0,0-8,17l-2.08,5.32-.58,1.45a2.11,2.11,0,0,1-.23.49,2,2,0,0,1,.13-.53c.13-.39.3-.88.49-1.48.44-1.28,1.08-3.12,1.93-5.39a107.18,107.18,0,0,1,7.89-17.15,52.08,52.08,0,0,1,12.2-14.36,35.46,35.46,0,0,1,4.76-3.2c.58-.35,1.07-.56,1.38-.72A2.49,2.49,0,0,1,533.74,277.68Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.30000000000000004
    }
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M494.6,315.87A66.38,66.38,0,0,0,489,345.78c.38,10.16,1.6,20.35.6,30.48s-4.51,20.46-12.06,27.27a9.81,9.81,0,0,0-2.44,2.71,2.75,2.75,0,0,0,.47,3.35,4,4,0,0,0,3.14.33c7.23-1.26,14.55-2.16,21.79-3.41,1.55-.27,6.76-1.29,6.76-1.29a28.28,28.28,0,0,1-.44-6c.23-1.81.94-8,.94-8a10.64,10.64,0,0,0-1.39-2.58,59.15,59.15,0,0,1-6-15.39c-2.47-5.05-3.58-10.13-4.73-14.85-3.17-13.11-3.08-26-1.06-42.61"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.30000000000000004
    }
  }, _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M415.33,300.94c.59,1.5,1.19,3,1.78,4.51a1.82,1.82,0,0,0,.86,1.13c.89.34,1.6-.75,2-1.61a11.55,11.55,0,0,1,8.87-6.23c3-.35,6.16.53,9.15-.09a40.54,40.54,0,0,0-8.26-4.11,13.7,13.7,0,0,0-9.07-.09,8.37,8.37,0,0,0-5.47,6.83"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.30000000000000004
    }
  }, _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M440.05,297.15a48.72,48.72,0,0,1,10.59,1,16.52,16.52,0,0,1,9.07,5.22c2.42,2.95,3.32,6.82,4.3,10.5.19.71.53,1.55,1.25,1.63a1.78,1.78,0,0,0,1.2-.47c6-4.4,9.94-11.13,12.1-18.23s2.66-14.58,2.78-22c-2.86,5.11-4.1,10.93-6,16.47s-4.67,11.12-9.57,14.32a4.78,4.78,0,0,0-1.12-3.51,10.48,10.48,0,0,0-2.91-2.38,27.8,27.8,0,0,0-22.26-2.73"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M424.51,414.94H412.26s-27.63-10-33.31-9c-5.12.86-23.85,13.3-27.52,15.77a2.31,2.31,0,0,0-.89,1.13h0a4,4,0,0,0,2.24,5.1l.38.16-.16.56a6.63,6.63,0,0,0-.29,2.24,2.7,2.7,0,0,0,5,1.16l-.7,1.26a3,3,0,0,0-.39,1.68l.06,1.13a3.08,3.08,0,0,0,2.12,2.76h0A3.07,3.07,0,0,0,362,438c2.38-2.61,7.51-7.84,11-8.42a81.13,81.13,0,0,1,11.34-.57,3.85,3.85,0,0,1,3.57,2.45h0c-2.06.15-16.42,7.64-21.5,10.32a5.41,5.41,0,0,0-2.95,4.09c-.19,1.59.61,3.25,3.76,2.52,6.75-1.58,18.9-7.16,18.9-7.16s6.26-1.79,10.32,1.07c5.71,4,8.33,5.51,13.23,3.88a41.54,41.54,0,0,0,8.52-4l9.66-1S437,418.44,424.51,414.94Z",
    style: {
      fill: "#ffbe9d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M388,419.6c0,.11-2-.51-5.19-.72a26.78,26.78,0,0,0-22.33,9.53,51.66,51.66,0,0,0-3.07,4.25,6.1,6.1,0,0,1,.61-1.28,23.23,23.23,0,0,1,2.17-3.2,25.94,25.94,0,0,1,22.65-9.66,24,24,0,0,1,3.81.64A6.5,6.5,0,0,1,388,419.6Z",
    style: {
      fill: "#eb996e"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M385.1,412.89a21,21,0,0,0-18,2.62A50.36,50.36,0,0,0,357,424.08L354.22,427a7.13,7.13,0,0,1-1.06,1,9.63,9.63,0,0,1,.91-1.18c.61-.74,1.51-1.79,2.66-3.06a46.54,46.54,0,0,1,10.13-8.77,23,23,0,0,1,12.85-3.48,15.44,15.44,0,0,1,4,.74,9,9,0,0,1,1,.39Z",
    style: {
      fill: "#eb996e"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--speech-bubble--inject-17"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M544.62,135.11a40.88,40.88,0,0,0-33.54,64.27l-4.91,15.25,15-5.11a40.89,40.89,0,1,0,23.42-74.41Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M533.84,175.68a3.53,3.53,0,1,1-3.42-3.63A3.53,3.53,0,0,1,533.84,175.68Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M548,176.11a3.53,3.53,0,1,1-3.42-3.63A3.53,3.53,0,0,1,548,176.11Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M562.07,174.77a3.53,3.53,0,1,1-4.77-1.44A3.52,3.52,0,0,1,562.07,174.77Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M545.88,134.83a2.93,2.93,0,0,1,.71,0l2.1.12c.46,0,1,0,1.54.11l1.84.32,2.15.37,2.39.67a39.23,39.23,0,0,1,11.52,5.45,41.21,41.21,0,0,1,18,31.55,42.7,42.7,0,0,1,0,5.65c-.1.95-.11,1.92-.28,2.88s-.35,1.92-.52,2.9A41.61,41.61,0,0,1,581,196.23a44.47,44.47,0,0,1-7.82,10.1,43.43,43.43,0,0,1-11.05,7.45,39.46,39.46,0,0,1-13.3,3.65,26,26,0,0,1-3.53.19,32.55,32.55,0,0,1-3.56,0,43,43,0,0,1-7.09-1.11,41.76,41.76,0,0,1-14-6.4l.43.06-14.61,5.36-.87.32.27-.88,4.71-15.31.06.38a41.32,41.32,0,0,1-7.17-17.86,37.37,37.37,0,0,1-.29-9.06,29.15,29.15,0,0,1,.54-4.32l.39-2.11c.15-.69.38-1.35.57-2a41.3,41.3,0,0,1,16.81-23,39.59,39.59,0,0,1,9.74-4.77l2.18-.71,2.07-.46,1.89-.4c.6-.1,1.18-.15,1.73-.21,1.1-.11,2.06-.27,2.9-.28h3.42a1.67,1.67,0,0,1,.44,0,1.89,1.89,0,0,1-.44,0l-1.29.07L542,135c-.83,0-1.79.22-2.87.35a41.05,41.05,0,0,0-33.75,29.46c-.17.66-.4,1.32-.54,2s-.25,1.38-.38,2.07a29.55,29.55,0,0,0-.51,4.25,37.36,37.36,0,0,0,.32,8.87,40.73,40.73,0,0,0,7.08,17.49l.13.17-.07.21q-2.26,7.43-4.67,15.32l-.6-.57,14.61-5.37.23-.09.2.14a40.65,40.65,0,0,0,13.68,6.24,40.12,40.12,0,0,0,6.93,1.09,31.09,31.09,0,0,0,3.48.05,26.25,26.25,0,0,0,3.44-.19,38.48,38.48,0,0,0,13-3.55,42.65,42.65,0,0,0,10.83-7.27,43.37,43.37,0,0,0,7.67-9.87,40.51,40.51,0,0,0,4.22-11.13c.18-1,.35-1.9.53-2.83s.18-1.9.28-2.83a43,43,0,0,0,.08-5.55,40.82,40.82,0,0,0-17.52-31.16,39.22,39.22,0,0,0-11.34-5.53l-2.36-.7-2.12-.42-1.82-.35c-.56-.08-1.08-.11-1.53-.16l-2.08-.22A5,5,0,0,1,545.88,134.83Z",
    style: {
      fill: "#263238"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Cat--inject-17"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M635,447.49a10.08,10.08,0,0,0-6.64,3.69,7.3,7.3,0,0,0-.93,7.35,5.77,5.77,0,0,0,6.45,3.16,3.65,3.65,0,0,0,7.29.12,4.35,4.35,0,0,0,7.62-3.18c-.08-1.15-.61-2.22-.74-3.35a36.16,36.16,0,0,1,.14-3.75,3.18,3.18,0,0,0-1.76-3.06",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M583.68,454.27a43.4,43.4,0,0,1,12.76-5.1c3.23-.83,6.7-1.51,9.87-.47a9.74,9.74,0,0,1,6.24,6.58,4.82,4.82,0,0,1-.16,3.51c-.75,1.41-2.41,2.06-4,2.44-1.18.3-2.7.39-3.36-.64a4.58,4.58,0,0,1-6.71.52,4.43,4.43,0,0,1-8.44-2.48,4.88,4.88,0,0,1-4.27,2.11,4,4,0,0,1-3.53-3,3.4,3.4,0,0,1,2.37-3.85",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M546.26,453.63a11,11,0,0,1,4.26-11.43c4-2.89,6.84-6.25,12.06-9.36a77.74,77.74,0,0,1,12.77-5.49c10.25-3.4,17.18-4.26,21.39-6.47,4.61-2.41,10.77-6.21,10.77-6.21l52.32,4.06s6.29,38.64-3.23,42.42c0,0-44.34.46-47.82-1.08-3.78-1.67-61.47-1.64-61.3-1.26Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M574.58,446.25a164.39,164.39,0,0,1-28.1,2.26,50.35,50.35,0,0,0-9.9.64,10.84,10.84,0,0,0-5.4,2.51,5.32,5.32,0,0,0-1.53,5.5c.71,1.88,3.2,3,4.91,1.95a4,4,0,0,0,7.3,1.41,3.38,3.38,0,0,0,3.21,1,13.26,13.26,0,0,0,3.28-1.27c4.56-2.13,9.41-1.6,14.45-1.57,8.8.06,18.76,0,15.09,0",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M577.89,458.69a6,6,0,0,1,.74-.05h0c0,.18,0,.05,0,.09h-.36l-.5,0-1.23,0-8,.09h-5.62c-2,0-4.22-.1-6.52,0a21,21,0,0,0-7.11,1.27,37,37,0,0,1-3.63,1.53,4.69,4.69,0,0,1-2.11.12,3.14,3.14,0,0,1-1.91-1.09l.42,0a4.25,4.25,0,0,1-7.78-1.49l.4.17a3.65,3.65,0,0,1-4.15-.51,3.89,3.89,0,0,1-1.37-2.44,5.28,5.28,0,0,1,.35-2.73,7.15,7.15,0,0,1,3.71-3.69,16.57,16.57,0,0,1,4.87-1.32,39.56,39.56,0,0,1,4.8-.34c6.23,0,11.83-.06,16.52-.41s8.48-.82,11.09-1.15l3-.39.78-.09h.27l-.26.07-.78.14-3,.48c-2.61.39-6.39.94-11.09,1.32s-10.33.47-16.54.52a40.56,40.56,0,0,0-4.74.35,16.31,16.31,0,0,0-4.72,1.29,6.61,6.61,0,0,0-3.45,3.43,3.91,3.91,0,0,0,.88,4.57,3.11,3.11,0,0,0,3.53.47l.32-.21.07.38a3.74,3.74,0,0,0,6.84,1.32l.19-.3.22.28a3.31,3.31,0,0,0,3.49.81,38.39,38.39,0,0,0,3.59-1.5,21.05,21.05,0,0,1,7.27-1.26c2.33-.05,4.51.08,6.54.09l5.61.05,8,.06,1.23,0h.86s0-.09,0,.09h0A3.81,3.81,0,0,1,577.89,458.69Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M647.89,456.64a2.76,2.76,0,0,1,.59.77,4.49,4.49,0,0,1,.48,2.7,4.65,4.65,0,0,1-.67,1.88,4,4,0,0,1-1.79,1.54,4.72,4.72,0,0,1-5.32-1.14l.36-.07a4.09,4.09,0,0,1-7.76,0l.3.16c-2.77.69-5.87-1.18-7-4a7.55,7.55,0,0,1,.43-6.35,10.31,10.31,0,0,1,4.18-4.27,14.39,14.39,0,0,1,5.16-1.63,22.64,22.64,0,0,1,4.7-.08,63.06,63.06,0,0,1,6.69,1l1.8.35a4.84,4.84,0,0,1,.62.15,2.38,2.38,0,0,1-.64,0l-1.82-.26c-1.58-.23-3.85-.67-6.68-.87a17.31,17.31,0,0,0-9.59,1.76,9.81,9.81,0,0,0-4,4.08,7,7,0,0,0-.41,5.92c1.08,2.6,4,4.31,6.44,3.69l.23,0,.07.22a3.71,3.71,0,0,0,3.62,2.5,3.78,3.78,0,0,0,3.26-2.45l.12-.35.24.28a4.35,4.35,0,0,0,4.86,1.1,4,4,0,0,0,2.35-3.14,4.46,4.46,0,0,0-.35-2.6C648.09,456.91,647.86,456.66,647.89,456.64Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M655.72,446.62c-.06.06-.6-.47-1.65-1a8.18,8.18,0,0,0-8.72.44c-1,.68-1.47,1.26-1.54,1.2a4.08,4.08,0,0,1,1.32-1.49,7.81,7.81,0,0,1,9.13-.47A4.06,4.06,0,0,1,655.72,446.62Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M583.49,460.39a2.24,2.24,0,0,1-.39-.26,4.5,4.5,0,0,1-.86-1,6.2,6.2,0,0,1-.56-4.81,9.76,9.76,0,0,1,4.7-5.44c2.38-1.43,5.3-2.22,8.13-3.48a27.84,27.84,0,0,0,14-14.59,13.34,13.34,0,0,1,.7-1.64,2.16,2.16,0,0,1-.1.45c-.09.29-.2.73-.41,1.26a23.78,23.78,0,0,1-2.11,4.4,27,27,0,0,1-11.88,10.6c-2.89,1.28-5.79,2-8.1,3.41a9.53,9.53,0,0,0-4.59,5.13,6.08,6.08,0,0,0,.38,4.61A7.06,7.06,0,0,0,583.49,460.39Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M604.33,460.07a5,5,0,0,0,1.14.89,4.33,4.33,0,0,0,3.74.06,5,5,0,0,0,2.59-4.73,6.56,6.56,0,0,0-.91-3.21,8.57,8.57,0,0,0-2.49-2.64,12,12,0,0,0-6.73-2,21.49,21.49,0,0,0-5.8.89c-1.62.46-2.91.92-3.8,1.22a9.4,9.4,0,0,1-1.41.44,7.13,7.13,0,0,1,1.33-.63c.88-.36,2.15-.87,3.78-1.38a20.42,20.42,0,0,1,5.9-1,12.18,12.18,0,0,1,7,2.08,8.83,8.83,0,0,1,2.64,2.81,7,7,0,0,1,.95,3.47,5.29,5.29,0,0,1-2.92,5.06,4.43,4.43,0,0,1-4-.21,3.24,3.24,0,0,1-.84-.73C604.38,460.2,604.32,460.09,604.33,460.07Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M598.5,460.8a4.44,4.44,0,0,0,1.67,1.08,4.87,4.87,0,0,0,2.08.35,2.77,2.77,0,0,0,2-1.35,3.17,3.17,0,0,0,.21-2.46,6.13,6.13,0,0,0-1-1.91,15.81,15.81,0,0,1-1.28-1.61,5.55,5.55,0,0,1,1.56,1.38,5.71,5.71,0,0,1,1.17,2,3.61,3.61,0,0,1-.21,2.86,3.23,3.23,0,0,1-2.42,1.57,4.78,4.78,0,0,1-2.28-.49,3.81,3.81,0,0,1-1.27-.91C598.51,461,598.47,460.81,598.5,460.8Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M590.1,458.93a6.49,6.49,0,0,1,0,.79,3.88,3.88,0,0,0,.55,2,3.62,3.62,0,0,0,2.39,1.74,4.27,4.27,0,0,0,3.51-.81,4.86,4.86,0,0,0,1.72-3.24,5.36,5.36,0,0,0-.58-3,9.68,9.68,0,0,0-1.82-2.27s.28.09.7.41a5.85,5.85,0,0,1,1.44,1.69,5.45,5.45,0,0,1,.74,3.22,5.22,5.22,0,0,1-1.87,3.59,4.71,4.71,0,0,1-4,.88,3.91,3.91,0,0,1-2.6-2,3.71,3.71,0,0,1-.43-2.18A1.56,1.56,0,0,1,590.1,458.93Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M610.87,423.67s11.07,12.19,24.8,10.65S660,419.46,660,419.46c2.11-3.35,1.24-6.81.58-9.37s-1.92-5-1.93-7.66c0-2.26.89-4.41,1.54-6.57,1.45-4.84,1.68-10,1.9-15,.09-2.17,0-4.75-1.86-5.91a4.16,4.16,0,0,0-3.87-.07,11.52,11.52,0,0,0-3.2,2.41,136.61,136.61,0,0,0-11.63,12.66,15.12,15.12,0,0,0-18.76,1.51c-5.87-2.46-7.81-10.69-13.82-12.8a4.32,4.32,0,0,0-4,.29c-1.47,1.1-1.55,3.22-1.49,5.05.25,8.23.55,16.7,3.9,24.22A16.25,16.25,0,0,0,610.54,423",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M631,425.41a5.52,5.52,0,0,1,6.82-1.94,1.85,1.85,0,0,1,.77.55.79.79,0,0,1,.07.89.68.68,0,0,0-1,0,1.61,1.61,0,0,0-.35,1.09,3.76,3.76,0,0,1-.13,1.16,1.43,1.43,0,0,1-1,.86,1.41,1.41,0,0,1-1.27-.43,4.47,4.47,0,0,1-.6-1.07,1.37,1.37,0,0,0-.87-.81,1.91,1.91,0,0,0-1,.21,1.27,1.27,0,0,1-.95.09c-.3-.14-.44-.61-.17-.79",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M636.08,426.93c.08,0,.06.44.22,1.09a4,4,0,0,0,3.65,3.09c.67.05,1.1-.05,1.12,0s-.38.29-1.12.34a3.94,3.94,0,0,1-2.68-.91,3.86,3.86,0,0,1-1.33-2.49C635.86,427.35,636,426.92,636.08,426.93Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M636.16,426.28c.05,0,.34.46.37,1.35a4.1,4.1,0,0,1-4.51,4.22c-.89-.09-1.35-.42-1.32-.47s.52.11,1.33.1a4,4,0,0,0,4.13-3.86C636.23,426.81,636.07,426.3,636.16,426.28Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M657.34,430.86A26.51,26.51,0,0,0,642.45,429a7,7,0,0,1,2.18-.59,19.63,19.63,0,0,1,10.74,1.33A6.81,6.81,0,0,1,657.34,430.86Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M663.71,428.15c0,.08-1.26-.23-3.27-.58a49.08,49.08,0,0,0-15.86-.27c-2,.29-3.26.55-3.28.47a3.12,3.12,0,0,1,.85-.29c.55-.17,1.36-.35,2.37-.55a40.6,40.6,0,0,1,16,.27c1,.23,1.81.45,2.36.63A3.05,3.05,0,0,1,663.71,428.15Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M667.08,421.06c0,.08-1.52,0-4,0a52.13,52.13,0,0,0-9.43.78,33.55,33.55,0,0,0-9,2.93c-2.17,1.09-3.38,2-3.43,1.92a4,4,0,0,1,.81-.69,23.19,23.19,0,0,1,2.45-1.56,30.66,30.66,0,0,1,9-3.12,44.74,44.74,0,0,1,9.54-.63c1.22,0,2.21.12,2.88.19A4.81,4.81,0,0,1,667.08,421.06Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M609.74,437s.19-.23.59-.58a19.35,19.35,0,0,1,1.78-1.35,27.75,27.75,0,0,1,13.83-4.67,18.45,18.45,0,0,1,2.23,0,2.76,2.76,0,0,1,.82.1c0,.09-1.16.09-3,.27a32.39,32.39,0,0,0-13.66,4.62C610.72,436.31,609.8,437,609.74,437Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M608.9,431.4s.26-.18.76-.4,1.24-.51,2.17-.83A36.28,36.28,0,0,1,627,428.54c1,.11,1.76.23,2.29.34a2.88,2.88,0,0,1,.83.23c0,.08-1.21-.08-3.16-.21a46.36,46.36,0,0,0-7.57.16,45.89,45.89,0,0,0-7.44,1.46A31.4,31.4,0,0,1,608.9,431.4Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M601.93,429.06a4.77,4.77,0,0,1,1-.48,28.7,28.7,0,0,1,2.95-1,42.47,42.47,0,0,1,20.33-.71c1.29.28,2.31.55,3,.78a4.22,4.22,0,0,1,1.07.4c0,.09-1.58-.36-4.15-.82A48.09,48.09,0,0,0,606,428C603.48,428.59,602,429.14,601.93,429.06Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M628.59,415.35a3.45,3.45,0,0,1-1.54,1.1,6.84,6.84,0,0,1-8.32-2.16,3.48,3.48,0,0,1-.81-1.71c.08,0,.37.63,1.1,1.48a7.06,7.06,0,0,0,7.89,2.05C628,415.72,628.54,415.28,628.59,415.35Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M650.86,410.55a2.66,2.66,0,0,1-.17,1.81,5.54,5.54,0,0,1-3.05,3.12,10.67,10.67,0,0,1-4.3.79,5.83,5.83,0,0,1-1.79-.14,6.52,6.52,0,0,1,1.78-.23,12.67,12.67,0,0,0,4.09-.89,5.68,5.68,0,0,0,2.93-2.79A15.91,15.91,0,0,0,650.86,410.55Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M612.11,395.81a10.85,10.85,0,0,0,1.67-2.12,4.75,4.75,0,0,0,.62-2.77,6,6,0,0,0-1.27-2.72,26.15,26.15,0,0,0-5.49-5.57s-1.58-1.2-2.29,0c-.48.8-.18,13.93,1.65,14.77S612.11,395.81,612.11,395.81Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M657.49,377c-2.92,2.29-4,6.23-6.23,9.23a8.82,8.82,0,0,0-1,1.71,2.86,2.86,0,0,0-.17,1.95,3.75,3.75,0,0,0,1.26,1.62,15,15,0,0,0,3.87,2.35s3,.93,3.83-1.82S659.45,375.5,657.49,377Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M564.57,433.69c-3.52.54-11.65-.81-14-3.26s-1.71-6.29-.42-9.6,3.27-6.31,5-9.43c2.84-5.23,4.9-11,5.06-16.94s-1.77-12.09-6-16.29-10.85-6.09-16.4-3.94c-4.56,1.77-8.09,7-6.33,11.6,1.11,2.86,3.88,4.67,5.83,7a14.44,14.44,0,0,1,2.88,12.19c-1,4.59-4.29,8.4-5.52,12.94-1.87,6.92,1.52,14.6,7.24,18.94s13.3,5.63,20.42,4.79",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M638.54,431.29s.43,2.68-.49,3.77a2.27,2.27,0,0,1-3.94-.42,6.1,6.1,0,0,1-.64-2.74s2.38-.86,2.72-2.25A3.81,3.81,0,0,0,638.54,431.29Z",
    style: {
      fill: "#E59124"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M650.66,432.38a4.78,4.78,0,0,1-.78.88,18,18,0,0,1-2.48,2,20.29,20.29,0,0,1-20.21,1.63,19,19,0,0,1-2.77-1.61,5.44,5.44,0,0,1-.91-.74c.06-.09,1.38.95,3.83,2A21,21,0,0,0,647.2,435C649.45,433.54,650.59,432.3,650.66,432.38Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M636.38,450.39c0,.08-.69.45-1.6,1.36a7.73,7.73,0,0,0-1.43,9.16c.59,1.14,1.18,1.72,1.11,1.78a4.27,4.27,0,0,1-1.43-1.6,7.56,7.56,0,0,1,1.5-9.61A4.18,4.18,0,0,1,636.38,450.39Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M646.12,451.55a10.87,10.87,0,0,0-2,.54,6.12,6.12,0,0,0-3.1,3.51,8.9,8.9,0,0,0-.07,4.8c.3,1.22.64,2,.56,2a4.85,4.85,0,0,1-.91-1.88,8.19,8.19,0,0,1-.07-5.07,6,6,0,0,1,3.45-3.68A3.07,3.07,0,0,1,646.12,451.55Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M619,445.08a4.71,4.71,0,0,1-.82,1.43,16.62,16.62,0,0,1-2.68,3,13.3,13.3,0,0,1-3.41,2.1,4.35,4.35,0,0,1-1.59.47c-.08-.17,2.34-1,4.67-3S618.86,445,619,445.08Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M606.92,415a3.3,3.3,0,0,1-.57.44c-.38.28-1,.66-1.72,1.14a59.63,59.63,0,0,1-6.68,3.56,101.21,101.21,0,0,1-10.47,4.05c-4,1.31-8.48,2.55-13.09,4.08a77,77,0,0,0-12.62,5.24,42.88,42.88,0,0,0-9.06,6.45,32.33,32.33,0,0,0-4.84,5.73c-1,1.49-1.4,2.38-1.45,2.35a3.25,3.25,0,0,1,.29-.65,18.79,18.79,0,0,1,1-1.81,30,30,0,0,1,4.76-5.89,41.88,41.88,0,0,1,9.08-6.6,74.68,74.68,0,0,1,12.68-5.31c4.63-1.54,9.11-2.76,13.12-4.05a107.13,107.13,0,0,0,10.46-3.93,71.69,71.69,0,0,0,6.73-3.39c.77-.45,1.36-.81,1.76-1.06A4.58,4.58,0,0,1,606.92,415Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M612.2,423.93a6.91,6.91,0,0,1-1.56-1.77,18,18,0,0,1-2.51-5.13,18.39,18.39,0,0,1-.8-5.65,7.31,7.31,0,0,1,.29-2.34,29.39,29.39,0,0,0,1,7.84A29.05,29.05,0,0,0,612.2,423.93Z",
    style: {
      fill: "#455a64"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Device--inject-17"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M251.74,457.81l-33.18-83.29a10.89,10.89,0,0,1,10.08-15H332a10.89,10.89,0,0,1,10.31,7.39l28.5,84,33.29.16c2.7,0,4.89,4,4.89,6.67h0l-36.64-.42Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M252.55,378.75a11.56,11.56,0,0,0-6.68,1.79,8.7,8.7,0,0,0-1.82,1.51c-1.77,2-4.93,5.86-3.67,11.9s5.15,6.87,7,7.07,14.52-3.41,14.52-3.41,4.6-3.91,3-9.05C263.43,384.15,259.35,379,252.55,378.75Z",
    style: {
      fill: "#E59124"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M246.49,399.22s.46,3.23,2.08,4,4.64.67,7,.09,5.76-1.9,6.16-3.69a7.53,7.53,0,0,0-.2-4.21,10.55,10.55,0,0,0-8.52-.79A11.26,11.26,0,0,0,246.49,399.22Z",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.4
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M256.78,383.8a6.08,6.08,0,1,1-7.38-4.42A6.09,6.09,0,0,1,256.78,383.8Z",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.4
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M241.43,397a7.8,7.8,0,0,0,1.73-5.16A7.6,7.6,0,0,0,240.9,387a14.92,14.92,0,0,0-.66,6.15A11.11,11.11,0,0,0,241.43,397Z",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.4
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M265.2,391.05a7.73,7.73,0,0,1-3.95-3.73,6.87,6.87,0,0,1-.39-5.09,16.89,16.89,0,0,1,3.45,4.85C265.49,389.87,265.2,391.05,265.2,391.05Z",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M299.52,412.09a6.72,6.72,0,1,1-6.72-6.71A6.72,6.72,0,0,1,299.52,412.09Z",
    style: {
      fill: "#f5f5f5"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Desk--inject-17"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M694.29,457.32c0,.14-137.46.26-307,.26s-307-.12-307-.26,137.43-.26,307-.26S694.29,457.17,694.29,457.32Z",
    style: {
      fill: "#263238"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Plant--inject-17"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M171.66,423c-9.78-5.67-15-18.86-15.4-29.66s4.1-22.05,13-28.24c9.32-6.52,22.6-6.4,32.18-.27s15.2,17.72,14.76,29.09-6.63,22.22-15.79,29",
    style: {
      fill: "#E59124"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M187.27,424a12.57,12.57,0,0,1-.18-2.47c-.05-1.77-.12-4-.19-6.73-.15-5.69-.37-13.54-.75-22.2s-.85-16.51-1.21-22.18c-.16-2.71-.29-5-.4-6.73a12,12,0,0,1,0-2.47,12.77,12.77,0,0,1,.39,2.44c.19,1.58.43,3.87.69,6.71.52,5.66,1.09,13.51,1.47,22.19s.5,16.54.48,22.23c0,2.84,0,5.15-.1,6.74A13.23,13.23,0,0,1,187.27,424Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M159.15,390.88c0,.25-1.58.33-3.48.17s-3.43-.49-3.41-.74,1.58-.33,3.48-.17S159.17,390.63,159.15,390.88Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M159.69,381.19c-.11.23-1.45-.14-3-.83s-2.73-1.44-2.63-1.67,1.45.14,3,.83S159.79,381,159.69,381.19Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M164.67,374c-.13.21-1.64-.5-3.22-1.8s-2.55-2.66-2.37-2.82,1.43.85,3,2.11S164.81,373.79,164.67,374Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M169.68,367.22c-.23.1-1-1-1.62-2.53s-1-2.8-.78-2.9,1,1,1.62,2.53S169.91,367.12,169.68,367.22Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M177.55,362.41c-.23.1-1-1.1-1.53-2.77s-.56-3.11-.32-3.15.69,1.27,1.2,2.87S177.78,362.3,177.55,362.41Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M190.67,357c.24.09.09,1.12-.33,2.3s-1,2.08-1.19,2-.09-1.12.33-2.3S190.43,356.9,190.67,357Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M200.4,361.16c.17.19-.45,1-1.39,1.91s-1.85,1.43-2,1.25.45-1.05,1.39-1.92S200.23,361,200.4,361.16Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M209,366.69c.14.21-.62,1-1.7,1.71s-2.08,1.15-2.22.94.62-1,1.7-1.7S208.83,366.48,209,366.69Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M215.05,374.94c.1.24-1.1,1-2.68,1.64s-2.94,1-3,.8,1.1-1,2.68-1.64S215,374.71,215.05,374.94Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M217.45,383.94c0,.25-1.19.61-2.73.8s-2.81.14-2.84-.11,1.19-.61,2.73-.8S217.42,383.69,217.45,383.94Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M218.69,395c-.1.23-1.4-.11-2.9-.77s-2.64-1.37-2.54-1.6,1.4.11,2.9.76S218.79,394.78,218.69,395Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M217.6,404.52c-.08.23-1.73-.16-3.45-1.29s-2.74-2.47-2.56-2.64,1.44.82,3.06,1.87S217.69,404.27,217.6,404.52Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M212.65,413.17c-.15.2-1.46-.57-2.72-1.93s-1.93-2.71-1.72-2.85,1.19.93,2.39,2.23S212.81,413,212.65,413.17Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M165.66,414.19c.12.22-1.26,1.17-3.07,2.11s-3.38,1.53-3.49,1.3,1.25-1.17,3.07-2.11S165.54,414,165.66,414.19Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M161.37,406.36c.1.23-1,1-2.46,1.62s-2.74,1-2.84.79,1-1,2.46-1.62S161.26,406.13,161.37,406.36Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M158.21,399.43c0,.25-1.32.65-3,.89s-3.12.24-3.16,0,1.33-.65,3-.89S158.18,399.18,158.21,399.43Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M168.56,395.61c.08.24-1.25.85-3,1.05s-3.19-.11-3.17-.35,1.39-.37,3.07-.56S168.49,395.36,168.56,395.61Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M177.16,387.06c.07.23-1,.77-2.4.9s-2.56-.17-2.53-.42,1.12-.36,2.44-.49S177.08,386.81,177.16,387.06Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M178.8,380.2c-.08.24-1.22.07-2.55-.39s-2.33-1-2.24-1.26,1.22-.07,2.54.39S178.88,380,178.8,380.2Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M182,373.27c-.17.18-1-.34-1.51-1.31s-.62-1.91-.38-2,.67.65,1.17,1.51S182.14,373.1,182,373.27Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M178.15,401.64c.06.25-.92.7-2.2,1a8.53,8.53,0,0,1-1.85.27l-.19-.54c.34-.06.55,0,.59.06s-.09.26-.36.46l-.18-.53a8.1,8.1,0,0,1,1.77-.61C177,401.45,178.09,401.4,178.15,401.64Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M179.92,413.79c.1.24-1.16.95-2.81,1.6s-3.05,1-3.14.74,1.16-.95,2.81-1.59S179.83,413.56,179.92,413.79Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M170.21,408.4c.08.24-.75.74-1.87,1.12s-2.09.49-2.17.25.76-.74,1.87-1.12S170.13,408.16,170.21,408.4Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M171,383.67c-.06.24-1.52.1-3.21-.51s-2.92-1.4-2.81-1.62,1.47.18,3.11.76S171,383.42,171,383.67Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M194.46,381c.14.21-.69,1-1.84,1.76s-2.21,1.21-2.34,1,.68-1,1.83-1.76S194.32,380.77,194.46,381Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M195.73,393.18c.06.25-.81.64-1.93.87s-2.06.22-2.12,0,.82-.64,1.94-.87S195.68,392.93,195.73,393.18Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M197.22,406.9c-.11.23-1.35-.12-2.78-.79s-2.51-1.38-2.4-1.61,1.35.12,2.78.78S197.33,406.67,197.22,406.9Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M194.08,420.25c-.2.16-1-.5-1.81-1.47s-1.29-1.9-1.1-2.06,1,.5,1.81,1.47S194.27,420.09,194.08,420.25Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M193.43,372c.16.19-.38.86-1.29,1.32s-1.77.49-1.84.25.6-.65,1.43-1.07S193.28,371.79,193.43,372Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M205,384.3c.08.23-1,.82-2.44,1s-2.64-.07-2.62-.31,1.14-.4,2.49-.6S204.87,384.06,205,384.3Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M202.66,373.26c.11.22-.95,1-2.45,1.45s-2.81.48-2.84.24,1.13-.65,2.56-1.11S202.54,373,202.66,373.26Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M207.46,401.41c0,.25-1.81.41-4,0s-3.82-1.18-3.74-1.41,1.8.13,3.9.5S207.47,401.15,207.46,401.41Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M203.18,417.45c-.15.2-1.48-.58-2.81-1.92s-2.11-2.67-1.91-2.82,1.27.88,2.56,2.17S203.34,417.25,203.18,417.45Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M184.37,360.2c.13.2-3.66,1.73-8,6.35a39.2,39.2,0,0,0-10,22.12,49.75,49.75,0,0,0,.6,13.55,105.59,105.59,0,0,0,2.54,10.87c.88,3.06,1.69,5.52,2.23,7.22a17.49,17.49,0,0,1,.77,2.67,15.38,15.38,0,0,1-1.11-2.55c-.64-1.67-1.55-4.1-2.51-7.15a91.49,91.49,0,0,1-2.75-10.92,48.56,48.56,0,0,1-.68-13.8c1.13-9.85,5.86-18,10.45-22.46a28.85,28.85,0,0,1,6-4.69,18.62,18.62,0,0,1,1.84-1C184.12,360.26,184.35,360.17,184.37,360.2Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M196.86,423.57c-.2-.1,2.06-3.58,4.12-9.85a55.58,55.58,0,0,0,2.46-25.3,47.43,47.43,0,0,0-3.9-13.5,31.81,31.81,0,0,0-6.65-9.26,24.19,24.19,0,0,0-6.52-4.12c-1.7-.71-2.71-.88-2.7-1a2.15,2.15,0,0,1,.75.05,14.27,14.27,0,0,1,2.08.56,22.78,22.78,0,0,1,6.82,4,31.31,31.31,0,0,1,7,9.39,46.68,46.68,0,0,1,4,13.73,53.69,53.69,0,0,1-2.76,25.65c-.51,1.58-1.18,2.93-1.68,4.16s-1.07,2.21-1.52,3A16.39,16.39,0,0,1,196.86,423.57Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "161.37 421.4 211.88 421.4 212.19 431.51 161.37 431.51 161.37 421.4",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "165.66 426.45 168.56 457.32 205.49 457.32 208.46 426.79 165.66 426.45",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M212.19,431.63c0,.25-11.37.46-25.4.46s-25.41-.21-25.41-.46,11.37-.46,25.41-.46S212.19,431.38,212.19,431.63Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M207.06,441A7.56,7.56,0,0,1,206,443a29.06,29.06,0,0,1-3.92,4.63l-.23.22-.23-.24a73.35,73.35,0,0,0-9.9-8.67l.56,0-4.39,3.85-5.19,4.52-.29.25-.29-.25-8.43-7.09.49-.05-4.36,5.32a12,12,0,0,1-1.72,1.88,13.8,13.8,0,0,1,1.41-2.11l4.13-5.52.21-.28.28.23,8.56,6.94h-.57l5.16-4.54,4.41-3.84.27-.23.29.21a65.18,65.18,0,0,1,9.85,8.94h-.46A52.28,52.28,0,0,0,207.06,441Z",
    style: {
      fill: "#455a64"
    }
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGrowth);
export default __webpack_public_path__ + "static/media/growth.15f36668a2eb4add1074fd0d494a8898.svg";
export { ForwardRef as ReactComponent };